/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUserInCognito = /* GraphQL */ `
  mutation CreateUserInCognito($input: CreateUserInCognitoInput!) {
    createUserInCognito(input: $input) {
      id
      teamGroup
      isActive
      email
      needsEmailChange
      firstName
      infix
      lastName
      avatarS3Url
      speakerID
      Speaker {
        id
        allowedCognitoGroups
        firstName
        infix
        lastName
        gender
        Subscriptions {
          nextToken
          startedAt
        }
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Languages {
          nextToken
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        LanguageLabels {
          nextToken
          startedAt
        }
        userID
        User {
          id
          teamGroup
          isActive
          email
          needsEmailChange
          firstName
          infix
          lastName
          avatarS3Url
          speakerID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      submittedLanguageLabels {
        items {
          id
          allowedCognitoGroups
          createdAt
          submittedAt
          validatedAt
          submitteduserID
          validateduserID
          clientID
          contextchannelID
          sessionID
          goldtranscriptID
          starttime
          endtime
          speakerID
          languageID
          languagedialectID
          content
          contentJson
          sentimentJson
          contentOrigin
          contentJsonOrigin
          sentimentJsonOrigin
          validationStatus
          feedbackMessage
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      validatedLanguageLabels {
        items {
          id
          allowedCognitoGroups
          createdAt
          submittedAt
          validatedAt
          submitteduserID
          validateduserID
          clientID
          contextchannelID
          sessionID
          goldtranscriptID
          starttime
          endtime
          speakerID
          languageID
          languagedialectID
          content
          contentJson
          sentimentJson
          contentOrigin
          contentJsonOrigin
          sentimentJsonOrigin
          validationStatus
          feedbackMessage
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      allowedContextchannels {
        items {
          id
          createdAt
          isActive
          userID
          contextchannelID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      ContextchannelSubscriptions {
        items {
          id
          createdAt
          userID
          contextchannelID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      SessionSubscriptions {
        items {
          id
          createdAt
          userID
          sessionID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      SpeakerSubscriptions {
        items {
          id
          createdAt
          userID
          speakerID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateCognitoGroupsForUser = /* GraphQL */ `
  mutation UpdateCognitoGroupsForUser($input: UpdateUserInCognitoInput!) {
    updateCognitoGroupsForUser(input: $input) {
      teamGroup
      clientGroups
      roleGroups
    }
  }
`;
export const disableUserInCognito = /* GraphQL */ `
  mutation DisableUserInCognito($input: DisableUserInCognitoInput!) {
    disableUserInCognito(input: $input) {
      id
      teamGroup
      isActive
      email
      needsEmailChange
      firstName
      infix
      lastName
      avatarS3Url
      speakerID
      Speaker {
        id
        allowedCognitoGroups
        firstName
        infix
        lastName
        gender
        Subscriptions {
          nextToken
          startedAt
        }
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Languages {
          nextToken
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        LanguageLabels {
          nextToken
          startedAt
        }
        userID
        User {
          id
          teamGroup
          isActive
          email
          needsEmailChange
          firstName
          infix
          lastName
          avatarS3Url
          speakerID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      submittedLanguageLabels {
        items {
          id
          allowedCognitoGroups
          createdAt
          submittedAt
          validatedAt
          submitteduserID
          validateduserID
          clientID
          contextchannelID
          sessionID
          goldtranscriptID
          starttime
          endtime
          speakerID
          languageID
          languagedialectID
          content
          contentJson
          sentimentJson
          contentOrigin
          contentJsonOrigin
          sentimentJsonOrigin
          validationStatus
          feedbackMessage
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      validatedLanguageLabels {
        items {
          id
          allowedCognitoGroups
          createdAt
          submittedAt
          validatedAt
          submitteduserID
          validateduserID
          clientID
          contextchannelID
          sessionID
          goldtranscriptID
          starttime
          endtime
          speakerID
          languageID
          languagedialectID
          content
          contentJson
          sentimentJson
          contentOrigin
          contentJsonOrigin
          sentimentJsonOrigin
          validationStatus
          feedbackMessage
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      allowedContextchannels {
        items {
          id
          createdAt
          isActive
          userID
          contextchannelID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      ContextchannelSubscriptions {
        items {
          id
          createdAt
          userID
          contextchannelID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      SessionSubscriptions {
        items {
          id
          createdAt
          userID
          sessionID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      SpeakerSubscriptions {
        items {
          id
          createdAt
          userID
          speakerID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createEnvironmentStatus = /* GraphQL */ `
  mutation CreateEnvironmentStatus(
    $input: CreateEnvironmentStatusInput!
    $condition: ModelEnvironmentStatusConditionInput
  ) {
    createEnvironmentStatus(input: $input, condition: $condition) {
      id
      underMaintanence
      notes
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateEnvironmentStatus = /* GraphQL */ `
  mutation UpdateEnvironmentStatus(
    $input: UpdateEnvironmentStatusInput!
    $condition: ModelEnvironmentStatusConditionInput
  ) {
    updateEnvironmentStatus(input: $input, condition: $condition) {
      id
      underMaintanence
      notes
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteEnvironmentStatus = /* GraphQL */ `
  mutation DeleteEnvironmentStatus(
    $input: DeleteEnvironmentStatusInput!
    $condition: ModelEnvironmentStatusConditionInput
  ) {
    deleteEnvironmentStatus(input: $input, condition: $condition) {
      id
      underMaintanence
      notes
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createClient = /* GraphQL */ `
  mutation CreateClient(
    $input: CreateClientInput!
    $condition: ModelClientConditionInput
  ) {
    createClient(input: $input, condition: $condition) {
      id
      displayName
      cognitoGroupName
      Contextchannels {
        items {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      Speakers {
        items {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateClient = /* GraphQL */ `
  mutation UpdateClient(
    $input: UpdateClientInput!
    $condition: ModelClientConditionInput
  ) {
    updateClient(input: $input, condition: $condition) {
      id
      displayName
      cognitoGroupName
      Contextchannels {
        items {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      Speakers {
        items {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteClient = /* GraphQL */ `
  mutation DeleteClient(
    $input: DeleteClientInput!
    $condition: ModelClientConditionInput
  ) {
    deleteClient(input: $input, condition: $condition) {
      id
      displayName
      cognitoGroupName
      Contextchannels {
        items {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      Speakers {
        items {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createWordTaggerModuleOutput = /* GraphQL */ `
  mutation CreateWordTaggerModuleOutput(
    $input: CreateWordTaggerModuleOutputInput!
    $condition: ModelWordTaggerModuleOutputConditionInput
  ) {
    createWordTaggerModuleOutput(input: $input, condition: $condition) {
      id
      createdAt
      clientID
      Client {
        id
        displayName
        cognitoGroupName
        Contextchannels {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      taggedWords {
        text
        tag
      }
      categories
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateWordTaggerModuleOutput = /* GraphQL */ `
  mutation UpdateWordTaggerModuleOutput(
    $input: UpdateWordTaggerModuleOutputInput!
    $condition: ModelWordTaggerModuleOutputConditionInput
  ) {
    updateWordTaggerModuleOutput(input: $input, condition: $condition) {
      id
      createdAt
      clientID
      Client {
        id
        displayName
        cognitoGroupName
        Contextchannels {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      taggedWords {
        text
        tag
      }
      categories
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteWordTaggerModuleOutput = /* GraphQL */ `
  mutation DeleteWordTaggerModuleOutput(
    $input: DeleteWordTaggerModuleOutputInput!
    $condition: ModelWordTaggerModuleOutputConditionInput
  ) {
    deleteWordTaggerModuleOutput(input: $input, condition: $condition) {
      id
      createdAt
      clientID
      Client {
        id
        displayName
        cognitoGroupName
        Contextchannels {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      taggedWords {
        text
        tag
      }
      categories
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createContextchannel = /* GraphQL */ `
  mutation CreateContextchannel(
    $input: CreateContextchannelInput!
    $condition: ModelContextchannelConditionInput
  ) {
    createContextchannel(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      name
      s3ImageUrl
      reference_id
      contactEmailAddresses
      Subscriptions {
        items {
          id
          createdAt
          userID
          contextchannelID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      allowedUsers {
        items {
          id
          createdAt
          isActive
          userID
          contextchannelID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      dynamicConfig
      wordTaggerModuleSettings {
        enabled
        categories
      }
      gnlpConfig {
        prompt
        maxTokens
        temperature
        key
        frequencyPenalty
        presencePenalty
        languageISO
      }
      gnlpTasks
      speechmodelID
      SpeechModel {
        id
        name
        description
        s3ImageUrl
        allowedCognitoGroups
        provider
        connectionString
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        languagedialectID
        LanguageDialect {
          id
          name
          ISO_639_2_dialect
          languageID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      wordcloudSettings {
        whitelist
        blacklist
      }
      precomputedWordCountsS3Key
      ClusteringModuleOutputs {
        items {
          id
          createdAt
          allowedCognitoGroups
          clientID
          contextchannelID
          key
          leafIDs
          linkageMatrixS3Url
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      NLPSteps {
        items {
          id
          createdAt
          allowedCognitoGroups
          enabled
          clientID
          contextchannelID
          nlpmodelversionID
          name
          outputKey
          inputstepID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      posmodelID
      POSModel {
        id
        modelTrainedAt
        name
        huggingfaceRef
        pipelineParametersJson
        inferenceParametersJson
        otherParametersJson
        basemodelID
        BaseModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        ChildModels {
          nextToken
          startedAt
        }
        nlpmodeltypeID
        NLPModelType {
          id
          name
          huggingfaceTask
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nermodelID
      NERModel {
        id
        modelTrainedAt
        name
        huggingfaceRef
        pipelineParametersJson
        inferenceParametersJson
        otherParametersJson
        basemodelID
        BaseModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        ChildModels {
          nextToken
          startedAt
        }
        nlpmodeltypeID
        NLPModelType {
          id
          name
          huggingfaceTask
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      summarymodelID
      SummaryModel {
        id
        modelTrainedAt
        name
        huggingfaceRef
        pipelineParametersJson
        inferenceParametersJson
        otherParametersJson
        basemodelID
        BaseModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        ChildModels {
          nextToken
          startedAt
        }
        nlpmodeltypeID
        NLPModelType {
          id
          name
          huggingfaceTask
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      sentimentmodelID
      SentimentModel {
        id
        modelTrainedAt
        name
        huggingfaceRef
        pipelineParametersJson
        inferenceParametersJson
        otherParametersJson
        basemodelID
        BaseModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        ChildModels {
          nextToken
          startedAt
        }
        nlpmodeltypeID
        NLPModelType {
          id
          name
          huggingfaceTask
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      categorymodelID
      CategoryModel {
        id
        modelTrainedAt
        name
        huggingfaceRef
        pipelineParametersJson
        inferenceParametersJson
        otherParametersJson
        basemodelID
        BaseModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        ChildModels {
          nextToken
          startedAt
        }
        nlpmodeltypeID
        NLPModelType {
          id
          name
          huggingfaceTask
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      clientID
      Client {
        id
        displayName
        cognitoGroupName
        Contextchannels {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      Sessions {
        items {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      Speakers {
        items {
          id
          createdAt
          contextchannelID
          speakerID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Languages {
        items {
          id
          createdAt
          enabled
          contextchannelID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      ContextchannelLogs {
        items {
          id
          allowedCognitoGroups
          createdAt
          clientID
          contextchannelID
          type
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateContextchannel = /* GraphQL */ `
  mutation UpdateContextchannel(
    $input: UpdateContextchannelInput!
    $condition: ModelContextchannelConditionInput
  ) {
    updateContextchannel(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      name
      s3ImageUrl
      reference_id
      contactEmailAddresses
      Subscriptions {
        items {
          id
          createdAt
          userID
          contextchannelID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      allowedUsers {
        items {
          id
          createdAt
          isActive
          userID
          contextchannelID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      dynamicConfig
      wordTaggerModuleSettings {
        enabled
        categories
      }
      gnlpConfig {
        prompt
        maxTokens
        temperature
        key
        frequencyPenalty
        presencePenalty
        languageISO
      }
      gnlpTasks
      speechmodelID
      SpeechModel {
        id
        name
        description
        s3ImageUrl
        allowedCognitoGroups
        provider
        connectionString
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        languagedialectID
        LanguageDialect {
          id
          name
          ISO_639_2_dialect
          languageID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      wordcloudSettings {
        whitelist
        blacklist
      }
      precomputedWordCountsS3Key
      ClusteringModuleOutputs {
        items {
          id
          createdAt
          allowedCognitoGroups
          clientID
          contextchannelID
          key
          leafIDs
          linkageMatrixS3Url
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      NLPSteps {
        items {
          id
          createdAt
          allowedCognitoGroups
          enabled
          clientID
          contextchannelID
          nlpmodelversionID
          name
          outputKey
          inputstepID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      posmodelID
      POSModel {
        id
        modelTrainedAt
        name
        huggingfaceRef
        pipelineParametersJson
        inferenceParametersJson
        otherParametersJson
        basemodelID
        BaseModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        ChildModels {
          nextToken
          startedAt
        }
        nlpmodeltypeID
        NLPModelType {
          id
          name
          huggingfaceTask
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nermodelID
      NERModel {
        id
        modelTrainedAt
        name
        huggingfaceRef
        pipelineParametersJson
        inferenceParametersJson
        otherParametersJson
        basemodelID
        BaseModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        ChildModels {
          nextToken
          startedAt
        }
        nlpmodeltypeID
        NLPModelType {
          id
          name
          huggingfaceTask
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      summarymodelID
      SummaryModel {
        id
        modelTrainedAt
        name
        huggingfaceRef
        pipelineParametersJson
        inferenceParametersJson
        otherParametersJson
        basemodelID
        BaseModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        ChildModels {
          nextToken
          startedAt
        }
        nlpmodeltypeID
        NLPModelType {
          id
          name
          huggingfaceTask
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      sentimentmodelID
      SentimentModel {
        id
        modelTrainedAt
        name
        huggingfaceRef
        pipelineParametersJson
        inferenceParametersJson
        otherParametersJson
        basemodelID
        BaseModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        ChildModels {
          nextToken
          startedAt
        }
        nlpmodeltypeID
        NLPModelType {
          id
          name
          huggingfaceTask
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      categorymodelID
      CategoryModel {
        id
        modelTrainedAt
        name
        huggingfaceRef
        pipelineParametersJson
        inferenceParametersJson
        otherParametersJson
        basemodelID
        BaseModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        ChildModels {
          nextToken
          startedAt
        }
        nlpmodeltypeID
        NLPModelType {
          id
          name
          huggingfaceTask
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      clientID
      Client {
        id
        displayName
        cognitoGroupName
        Contextchannels {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      Sessions {
        items {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      Speakers {
        items {
          id
          createdAt
          contextchannelID
          speakerID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Languages {
        items {
          id
          createdAt
          enabled
          contextchannelID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      ContextchannelLogs {
        items {
          id
          allowedCognitoGroups
          createdAt
          clientID
          contextchannelID
          type
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteContextchannel = /* GraphQL */ `
  mutation DeleteContextchannel(
    $input: DeleteContextchannelInput!
    $condition: ModelContextchannelConditionInput
  ) {
    deleteContextchannel(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      name
      s3ImageUrl
      reference_id
      contactEmailAddresses
      Subscriptions {
        items {
          id
          createdAt
          userID
          contextchannelID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      allowedUsers {
        items {
          id
          createdAt
          isActive
          userID
          contextchannelID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      dynamicConfig
      wordTaggerModuleSettings {
        enabled
        categories
      }
      gnlpConfig {
        prompt
        maxTokens
        temperature
        key
        frequencyPenalty
        presencePenalty
        languageISO
      }
      gnlpTasks
      speechmodelID
      SpeechModel {
        id
        name
        description
        s3ImageUrl
        allowedCognitoGroups
        provider
        connectionString
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        languagedialectID
        LanguageDialect {
          id
          name
          ISO_639_2_dialect
          languageID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      wordcloudSettings {
        whitelist
        blacklist
      }
      precomputedWordCountsS3Key
      ClusteringModuleOutputs {
        items {
          id
          createdAt
          allowedCognitoGroups
          clientID
          contextchannelID
          key
          leafIDs
          linkageMatrixS3Url
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      NLPSteps {
        items {
          id
          createdAt
          allowedCognitoGroups
          enabled
          clientID
          contextchannelID
          nlpmodelversionID
          name
          outputKey
          inputstepID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      posmodelID
      POSModel {
        id
        modelTrainedAt
        name
        huggingfaceRef
        pipelineParametersJson
        inferenceParametersJson
        otherParametersJson
        basemodelID
        BaseModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        ChildModels {
          nextToken
          startedAt
        }
        nlpmodeltypeID
        NLPModelType {
          id
          name
          huggingfaceTask
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nermodelID
      NERModel {
        id
        modelTrainedAt
        name
        huggingfaceRef
        pipelineParametersJson
        inferenceParametersJson
        otherParametersJson
        basemodelID
        BaseModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        ChildModels {
          nextToken
          startedAt
        }
        nlpmodeltypeID
        NLPModelType {
          id
          name
          huggingfaceTask
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      summarymodelID
      SummaryModel {
        id
        modelTrainedAt
        name
        huggingfaceRef
        pipelineParametersJson
        inferenceParametersJson
        otherParametersJson
        basemodelID
        BaseModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        ChildModels {
          nextToken
          startedAt
        }
        nlpmodeltypeID
        NLPModelType {
          id
          name
          huggingfaceTask
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      sentimentmodelID
      SentimentModel {
        id
        modelTrainedAt
        name
        huggingfaceRef
        pipelineParametersJson
        inferenceParametersJson
        otherParametersJson
        basemodelID
        BaseModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        ChildModels {
          nextToken
          startedAt
        }
        nlpmodeltypeID
        NLPModelType {
          id
          name
          huggingfaceTask
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      categorymodelID
      CategoryModel {
        id
        modelTrainedAt
        name
        huggingfaceRef
        pipelineParametersJson
        inferenceParametersJson
        otherParametersJson
        basemodelID
        BaseModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        ChildModels {
          nextToken
          startedAt
        }
        nlpmodeltypeID
        NLPModelType {
          id
          name
          huggingfaceTask
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      clientID
      Client {
        id
        displayName
        cognitoGroupName
        Contextchannels {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      Sessions {
        items {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      Speakers {
        items {
          id
          createdAt
          contextchannelID
          speakerID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Languages {
        items {
          id
          createdAt
          enabled
          contextchannelID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      ContextchannelLogs {
        items {
          id
          allowedCognitoGroups
          createdAt
          clientID
          contextchannelID
          type
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createContextchannelLanguages = /* GraphQL */ `
  mutation CreateContextchannelLanguages(
    $input: CreateContextchannelLanguagesInput!
    $condition: ModelContextchannelLanguagesConditionInput
  ) {
    createContextchannelLanguages(input: $input, condition: $condition) {
      id
      createdAt
      enabled
      contextchannelID
      contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languageID
      language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      dialects {
        items {
          id
          createdAt
          enabled
          contextchannellanguageID
          languagedialectID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateContextchannelLanguages = /* GraphQL */ `
  mutation UpdateContextchannelLanguages(
    $input: UpdateContextchannelLanguagesInput!
    $condition: ModelContextchannelLanguagesConditionInput
  ) {
    updateContextchannelLanguages(input: $input, condition: $condition) {
      id
      createdAt
      enabled
      contextchannelID
      contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languageID
      language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      dialects {
        items {
          id
          createdAt
          enabled
          contextchannellanguageID
          languagedialectID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteContextchannelLanguages = /* GraphQL */ `
  mutation DeleteContextchannelLanguages(
    $input: DeleteContextchannelLanguagesInput!
    $condition: ModelContextchannelLanguagesConditionInput
  ) {
    deleteContextchannelLanguages(input: $input, condition: $condition) {
      id
      createdAt
      enabled
      contextchannelID
      contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languageID
      language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      dialects {
        items {
          id
          createdAt
          enabled
          contextchannellanguageID
          languagedialectID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createContextchannelLanguageLanguageDialects = /* GraphQL */ `
  mutation CreateContextchannelLanguageLanguageDialects(
    $input: CreateContextchannelLanguageLanguageDialectsInput!
    $condition: ModelContextchannelLanguageLanguageDialectsConditionInput
  ) {
    createContextchannelLanguageLanguageDialects(
      input: $input
      condition: $condition
    ) {
      id
      createdAt
      enabled
      contextchannellanguageID
      contextchannellanguage {
        id
        createdAt
        enabled
        contextchannelID
        contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        languageID
        language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        dialects {
          nextToken
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languagedialectID
      languagedialect {
        id
        name
        ISO_639_2_dialect
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateContextchannelLanguageLanguageDialects = /* GraphQL */ `
  mutation UpdateContextchannelLanguageLanguageDialects(
    $input: UpdateContextchannelLanguageLanguageDialectsInput!
    $condition: ModelContextchannelLanguageLanguageDialectsConditionInput
  ) {
    updateContextchannelLanguageLanguageDialects(
      input: $input
      condition: $condition
    ) {
      id
      createdAt
      enabled
      contextchannellanguageID
      contextchannellanguage {
        id
        createdAt
        enabled
        contextchannelID
        contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        languageID
        language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        dialects {
          nextToken
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languagedialectID
      languagedialect {
        id
        name
        ISO_639_2_dialect
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteContextchannelLanguageLanguageDialects = /* GraphQL */ `
  mutation DeleteContextchannelLanguageLanguageDialects(
    $input: DeleteContextchannelLanguageLanguageDialectsInput!
    $condition: ModelContextchannelLanguageLanguageDialectsConditionInput
  ) {
    deleteContextchannelLanguageLanguageDialects(
      input: $input
      condition: $condition
    ) {
      id
      createdAt
      enabled
      contextchannellanguageID
      contextchannellanguage {
        id
        createdAt
        enabled
        contextchannelID
        contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        languageID
        language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        dialects {
          nextToken
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languagedialectID
      languagedialect {
        id
        name
        ISO_639_2_dialect
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createContextchannelSpeakers = /* GraphQL */ `
  mutation CreateContextchannelSpeakers(
    $input: CreateContextchannelSpeakersInput!
    $condition: ModelContextchannelSpeakersConditionInput
  ) {
    createContextchannelSpeakers(input: $input, condition: $condition) {
      id
      createdAt
      contextchannelID
      contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      speakerID
      speaker {
        id
        allowedCognitoGroups
        firstName
        infix
        lastName
        gender
        Subscriptions {
          nextToken
          startedAt
        }
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Languages {
          nextToken
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        LanguageLabels {
          nextToken
          startedAt
        }
        userID
        User {
          id
          teamGroup
          isActive
          email
          needsEmailChange
          firstName
          infix
          lastName
          avatarS3Url
          speakerID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateContextchannelSpeakers = /* GraphQL */ `
  mutation UpdateContextchannelSpeakers(
    $input: UpdateContextchannelSpeakersInput!
    $condition: ModelContextchannelSpeakersConditionInput
  ) {
    updateContextchannelSpeakers(input: $input, condition: $condition) {
      id
      createdAt
      contextchannelID
      contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      speakerID
      speaker {
        id
        allowedCognitoGroups
        firstName
        infix
        lastName
        gender
        Subscriptions {
          nextToken
          startedAt
        }
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Languages {
          nextToken
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        LanguageLabels {
          nextToken
          startedAt
        }
        userID
        User {
          id
          teamGroup
          isActive
          email
          needsEmailChange
          firstName
          infix
          lastName
          avatarS3Url
          speakerID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteContextchannelSpeakers = /* GraphQL */ `
  mutation DeleteContextchannelSpeakers(
    $input: DeleteContextchannelSpeakersInput!
    $condition: ModelContextchannelSpeakersConditionInput
  ) {
    deleteContextchannelSpeakers(input: $input, condition: $condition) {
      id
      createdAt
      contextchannelID
      contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      speakerID
      speaker {
        id
        allowedCognitoGroups
        firstName
        infix
        lastName
        gender
        Subscriptions {
          nextToken
          startedAt
        }
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Languages {
          nextToken
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        LanguageLabels {
          nextToken
          startedAt
        }
        userID
        User {
          id
          teamGroup
          isActive
          email
          needsEmailChange
          firstName
          infix
          lastName
          avatarS3Url
          speakerID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createContextchannelLog = /* GraphQL */ `
  mutation CreateContextchannelLog(
    $input: CreateContextchannelLogInput!
    $condition: ModelContextchannelLogConditionInput
  ) {
    createContextchannelLog(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      createdAt
      clientID
      contextchannelID
      Contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      type
      ApiCallLogEntry {
        ipAddress
        userName
        method
        route
        httpVersion
        statusCode
        userAgent
      }
      SessionStatusUpdateLogEntry {
        sessionID
        sessionName
        attributeName
        oldValue
        newValue
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateContextchannelLog = /* GraphQL */ `
  mutation UpdateContextchannelLog(
    $input: UpdateContextchannelLogInput!
    $condition: ModelContextchannelLogConditionInput
  ) {
    updateContextchannelLog(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      createdAt
      clientID
      contextchannelID
      Contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      type
      ApiCallLogEntry {
        ipAddress
        userName
        method
        route
        httpVersion
        statusCode
        userAgent
      }
      SessionStatusUpdateLogEntry {
        sessionID
        sessionName
        attributeName
        oldValue
        newValue
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteContextchannelLog = /* GraphQL */ `
  mutation DeleteContextchannelLog(
    $input: DeleteContextchannelLogInput!
    $condition: ModelContextchannelLogConditionInput
  ) {
    deleteContextchannelLog(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      createdAt
      clientID
      contextchannelID
      Contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      type
      ApiCallLogEntry {
        ipAddress
        userName
        method
        route
        httpVersion
        statusCode
        userAgent
      }
      SessionStatusUpdateLogEntry {
        sessionID
        sessionName
        attributeName
        oldValue
        newValue
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createSession = /* GraphQL */ `
  mutation CreateSession(
    $input: CreateSessionInput!
    $condition: ModelSessionConditionInput
  ) {
    createSession(input: $input, condition: $condition) {
      id
      createdAt
      name
      clientID
      allowedCognitoGroups
      wordcloudSettings {
        whitelist
        blacklist
      }
      wordTaggerModuleOutputs {
        items {
          id
          createdAt
          clientID
          sessionID
          categories
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      gnlpOutputs
      NLPOutputs {
        items {
          id
          createdAt
          allowedCognitoGroups
          clientID
          contextchannelID
          sessionID
          nlpstepID
          nlpmodelversionID
          inputnlpoutputID
          key
          outputType
          languageID
          value
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      title
      summary
      keywords
      rewrittenS3Key
      condensed
      category
      sourceFileS3Key
      s3ImageUrl
      metadataID
      Metadata {
        id
        allowedCognitoGroups
        metadataS3Key
        durationSeconds
        metadataStatus
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      audioID
      Audio {
        id
        allowedCognitoGroups
        uncompressedAudioS3Key
        compressedAudioS3Key
        waveformDataS3Key
        audioStatus
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      videoID
      Video {
        id
        allowedCognitoGroups
        compressedVideoS3Key
        videoStatus
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      autotranscriptID
      AutoTranscript {
        id
        allowedCognitoGroups
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        transcriptSourceS3Key
        transcriptStandardizedS3Key
        transcriptTranslationS3Keys
        transcriptionStatus
        exportPlainTextS3Key
        exportJsonS3Key
        subtitlesSrtS3Key
        subtitlesVttS3Key
        subtitleStatus
        diarizationS3Key
        summaryS3Key
        categoriesJson
        autotranscriptstatsID
        AutoTranscriptStats {
          id
          allowedCognitoGroups
          unknowns
          wordCount
          unknownPercentage
          globalConfidence
          knownConfidence
          autotranscriptID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      goldtranscriptID
      GoldTranscript {
        id
        allowedCognitoGroups
        validationProgressStatus
        LanguageLabels {
          nextToken
          startedAt
        }
        transcriptS3Key
        subtitlesSrtS3Key
        subtitlesVttS3Key
        subtitleStatus
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      customtranscriptID
      CustomTranscript {
        id
        allowedCognitoGroups
        transcriptS3Key
        subtitlesSrtS3Key
        subtitlesVttS3Key
        subtitleStatus
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      metadataStatus
      audioStatus
      videoStatus
      transcriptionStatus
      diarizationStatus
      subtitleStatus
      gnlpStatus
      nlpStatus
      contextchannelID
      Contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      Speakers {
        items {
          id
          createdAt
          isDefaultSpeaker
          sessionID
          speakerID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Languages {
        items {
          id
          createdAt
          isDefaultLanguage
          sessionID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      contactEmailAddresses
      Subscriptions {
        items {
          id
          createdAt
          userID
          sessionID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      validationProgressStatus
      extra
      tags {
        key
        value
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateSession = /* GraphQL */ `
  mutation UpdateSession(
    $input: UpdateSessionInput!
    $condition: ModelSessionConditionInput
  ) {
    updateSession(input: $input, condition: $condition) {
      id
      createdAt
      name
      clientID
      allowedCognitoGroups
      wordcloudSettings {
        whitelist
        blacklist
      }
      wordTaggerModuleOutputs {
        items {
          id
          createdAt
          clientID
          sessionID
          categories
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      gnlpOutputs
      NLPOutputs {
        items {
          id
          createdAt
          allowedCognitoGroups
          clientID
          contextchannelID
          sessionID
          nlpstepID
          nlpmodelversionID
          inputnlpoutputID
          key
          outputType
          languageID
          value
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      title
      summary
      keywords
      rewrittenS3Key
      condensed
      category
      sourceFileS3Key
      s3ImageUrl
      metadataID
      Metadata {
        id
        allowedCognitoGroups
        metadataS3Key
        durationSeconds
        metadataStatus
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      audioID
      Audio {
        id
        allowedCognitoGroups
        uncompressedAudioS3Key
        compressedAudioS3Key
        waveformDataS3Key
        audioStatus
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      videoID
      Video {
        id
        allowedCognitoGroups
        compressedVideoS3Key
        videoStatus
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      autotranscriptID
      AutoTranscript {
        id
        allowedCognitoGroups
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        transcriptSourceS3Key
        transcriptStandardizedS3Key
        transcriptTranslationS3Keys
        transcriptionStatus
        exportPlainTextS3Key
        exportJsonS3Key
        subtitlesSrtS3Key
        subtitlesVttS3Key
        subtitleStatus
        diarizationS3Key
        summaryS3Key
        categoriesJson
        autotranscriptstatsID
        AutoTranscriptStats {
          id
          allowedCognitoGroups
          unknowns
          wordCount
          unknownPercentage
          globalConfidence
          knownConfidence
          autotranscriptID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      goldtranscriptID
      GoldTranscript {
        id
        allowedCognitoGroups
        validationProgressStatus
        LanguageLabels {
          nextToken
          startedAt
        }
        transcriptS3Key
        subtitlesSrtS3Key
        subtitlesVttS3Key
        subtitleStatus
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      customtranscriptID
      CustomTranscript {
        id
        allowedCognitoGroups
        transcriptS3Key
        subtitlesSrtS3Key
        subtitlesVttS3Key
        subtitleStatus
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      metadataStatus
      audioStatus
      videoStatus
      transcriptionStatus
      diarizationStatus
      subtitleStatus
      gnlpStatus
      nlpStatus
      contextchannelID
      Contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      Speakers {
        items {
          id
          createdAt
          isDefaultSpeaker
          sessionID
          speakerID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Languages {
        items {
          id
          createdAt
          isDefaultLanguage
          sessionID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      contactEmailAddresses
      Subscriptions {
        items {
          id
          createdAt
          userID
          sessionID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      validationProgressStatus
      extra
      tags {
        key
        value
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteSession = /* GraphQL */ `
  mutation DeleteSession(
    $input: DeleteSessionInput!
    $condition: ModelSessionConditionInput
  ) {
    deleteSession(input: $input, condition: $condition) {
      id
      createdAt
      name
      clientID
      allowedCognitoGroups
      wordcloudSettings {
        whitelist
        blacklist
      }
      wordTaggerModuleOutputs {
        items {
          id
          createdAt
          clientID
          sessionID
          categories
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      gnlpOutputs
      NLPOutputs {
        items {
          id
          createdAt
          allowedCognitoGroups
          clientID
          contextchannelID
          sessionID
          nlpstepID
          nlpmodelversionID
          inputnlpoutputID
          key
          outputType
          languageID
          value
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      title
      summary
      keywords
      rewrittenS3Key
      condensed
      category
      sourceFileS3Key
      s3ImageUrl
      metadataID
      Metadata {
        id
        allowedCognitoGroups
        metadataS3Key
        durationSeconds
        metadataStatus
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      audioID
      Audio {
        id
        allowedCognitoGroups
        uncompressedAudioS3Key
        compressedAudioS3Key
        waveformDataS3Key
        audioStatus
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      videoID
      Video {
        id
        allowedCognitoGroups
        compressedVideoS3Key
        videoStatus
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      autotranscriptID
      AutoTranscript {
        id
        allowedCognitoGroups
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        transcriptSourceS3Key
        transcriptStandardizedS3Key
        transcriptTranslationS3Keys
        transcriptionStatus
        exportPlainTextS3Key
        exportJsonS3Key
        subtitlesSrtS3Key
        subtitlesVttS3Key
        subtitleStatus
        diarizationS3Key
        summaryS3Key
        categoriesJson
        autotranscriptstatsID
        AutoTranscriptStats {
          id
          allowedCognitoGroups
          unknowns
          wordCount
          unknownPercentage
          globalConfidence
          knownConfidence
          autotranscriptID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      goldtranscriptID
      GoldTranscript {
        id
        allowedCognitoGroups
        validationProgressStatus
        LanguageLabels {
          nextToken
          startedAt
        }
        transcriptS3Key
        subtitlesSrtS3Key
        subtitlesVttS3Key
        subtitleStatus
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      customtranscriptID
      CustomTranscript {
        id
        allowedCognitoGroups
        transcriptS3Key
        subtitlesSrtS3Key
        subtitlesVttS3Key
        subtitleStatus
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      metadataStatus
      audioStatus
      videoStatus
      transcriptionStatus
      diarizationStatus
      subtitleStatus
      gnlpStatus
      nlpStatus
      contextchannelID
      Contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      Speakers {
        items {
          id
          createdAt
          isDefaultSpeaker
          sessionID
          speakerID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Languages {
        items {
          id
          createdAt
          isDefaultLanguage
          sessionID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      contactEmailAddresses
      Subscriptions {
        items {
          id
          createdAt
          userID
          sessionID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      validationProgressStatus
      extra
      tags {
        key
        value
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createNLPModelVersion = /* GraphQL */ `
  mutation CreateNLPModelVersion(
    $input: CreateNLPModelVersionInput!
    $condition: ModelNLPModelVersionConditionInput
  ) {
    createNLPModelVersion(input: $input, condition: $condition) {
      id
      createdAt
      allowedCognitoGroups
      name
      HFModelType
      parentmodelID
      ParentModel {
        id
        createdAt
        allowedCognitoGroups
        name
        HFModelType
        parentmodelID
        ParentModel {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        childModels {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        NLPOutputs {
          nextToken
          startedAt
        }
        modelVersionType
        checkpointKey
        checkpointStorageType
        inputlanguageID
        inputLanguage {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        outputlanguageID
        outputLanguage {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        inputParameters {
          includeSpeakerInInput
          parseSpeakerFromOutput
          batchSize
          maxInputChunkLength
          inputChunkOverlapTokens
          outputChunkOverlapTokens
          outputChunkOverlapDiscardLastTokens
          truncateInput
          maxRecursionDepth
          maxRecursiveOutputLength
          allowConcatenatedOutput
          badGenerationResampleTries
          inputPrefix
          inputSuffix
          outputStartWith
          outputSeperators
          returnNMostFrequentOutputs
        }
        inferenceParameters {
          useCache
          maxNewTokens
          minNewTokens
          earlyStopping
          doSample
          numBeams
          penaltyAlpha
          temperature
          topK
          topP
          diversityPenalty
          lengthPenalty
          exponentialDecayLengthPenaltyStartIndex
          exponentialDecayLengthPenaltyDecayFactor
          repetitionPenalty
          encoderRepetitionPenalty
          noRepeatNgramSize
          encoderNoRepeatNgramSize
          forceWords
          badWords
          suppressTokens
        }
        modelParameters {
          hasQuantizedWeights
          skipQuantizeLayers
          gptqWbits
          gptqGroupsize
          loadIn8bit
          loadIn8bitThreshold
          loadIn8bitSkipModules
          torchDtype
          fromTf
          fromFlax
          ignoreMismatchedSizes
        }
        openAIParameters {
          endpoint
          model
          temperature
          maxTokens
          topP
          frequencyPenalty
          presencePenalty
          stop
        }
        outputType
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      childModels {
        items {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      NLPSteps {
        items {
          id
          createdAt
          allowedCognitoGroups
          enabled
          clientID
          contextchannelID
          nlpmodelversionID
          name
          outputKey
          inputstepID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      NLPOutputs {
        items {
          id
          createdAt
          allowedCognitoGroups
          clientID
          contextchannelID
          sessionID
          nlpstepID
          nlpmodelversionID
          inputnlpoutputID
          key
          outputType
          languageID
          value
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      modelVersionType
      checkpointKey
      checkpointStorageType
      inputlanguageID
      inputLanguage {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      outputlanguageID
      outputLanguage {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      inputParameters {
        includeSpeakerInInput
        parseSpeakerFromOutput
        batchSize
        maxInputChunkLength
        inputChunkOverlapTokens
        outputChunkOverlapTokens
        outputChunkOverlapDiscardLastTokens
        truncateInput
        maxRecursionDepth
        maxRecursiveOutputLength
        allowConcatenatedOutput
        badGenerationResampleTries
        inputPrefix
        inputSuffix
        outputStartWith
        outputSeperators
        returnNMostFrequentOutputs
      }
      inferenceParameters {
        useCache
        maxNewTokens
        minNewTokens
        earlyStopping
        doSample
        numBeams
        penaltyAlpha
        temperature
        topK
        topP
        diversityPenalty
        lengthPenalty
        exponentialDecayLengthPenaltyStartIndex
        exponentialDecayLengthPenaltyDecayFactor
        repetitionPenalty
        encoderRepetitionPenalty
        noRepeatNgramSize
        encoderNoRepeatNgramSize
        forceWords
        badWords
        suppressTokens
      }
      modelParameters {
        hasQuantizedWeights
        skipQuantizeLayers
        gptqWbits
        gptqGroupsize
        loadIn8bit
        loadIn8bitThreshold
        loadIn8bitSkipModules
        torchDtype
        fromTf
        fromFlax
        ignoreMismatchedSizes
      }
      openAIParameters {
        endpoint
        model
        temperature
        maxTokens
        topP
        frequencyPenalty
        presencePenalty
        stop
      }
      outputType
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateNLPModelVersion = /* GraphQL */ `
  mutation UpdateNLPModelVersion(
    $input: UpdateNLPModelVersionInput!
    $condition: ModelNLPModelVersionConditionInput
  ) {
    updateNLPModelVersion(input: $input, condition: $condition) {
      id
      createdAt
      allowedCognitoGroups
      name
      HFModelType
      parentmodelID
      ParentModel {
        id
        createdAt
        allowedCognitoGroups
        name
        HFModelType
        parentmodelID
        ParentModel {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        childModels {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        NLPOutputs {
          nextToken
          startedAt
        }
        modelVersionType
        checkpointKey
        checkpointStorageType
        inputlanguageID
        inputLanguage {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        outputlanguageID
        outputLanguage {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        inputParameters {
          includeSpeakerInInput
          parseSpeakerFromOutput
          batchSize
          maxInputChunkLength
          inputChunkOverlapTokens
          outputChunkOverlapTokens
          outputChunkOverlapDiscardLastTokens
          truncateInput
          maxRecursionDepth
          maxRecursiveOutputLength
          allowConcatenatedOutput
          badGenerationResampleTries
          inputPrefix
          inputSuffix
          outputStartWith
          outputSeperators
          returnNMostFrequentOutputs
        }
        inferenceParameters {
          useCache
          maxNewTokens
          minNewTokens
          earlyStopping
          doSample
          numBeams
          penaltyAlpha
          temperature
          topK
          topP
          diversityPenalty
          lengthPenalty
          exponentialDecayLengthPenaltyStartIndex
          exponentialDecayLengthPenaltyDecayFactor
          repetitionPenalty
          encoderRepetitionPenalty
          noRepeatNgramSize
          encoderNoRepeatNgramSize
          forceWords
          badWords
          suppressTokens
        }
        modelParameters {
          hasQuantizedWeights
          skipQuantizeLayers
          gptqWbits
          gptqGroupsize
          loadIn8bit
          loadIn8bitThreshold
          loadIn8bitSkipModules
          torchDtype
          fromTf
          fromFlax
          ignoreMismatchedSizes
        }
        openAIParameters {
          endpoint
          model
          temperature
          maxTokens
          topP
          frequencyPenalty
          presencePenalty
          stop
        }
        outputType
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      childModels {
        items {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      NLPSteps {
        items {
          id
          createdAt
          allowedCognitoGroups
          enabled
          clientID
          contextchannelID
          nlpmodelversionID
          name
          outputKey
          inputstepID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      NLPOutputs {
        items {
          id
          createdAt
          allowedCognitoGroups
          clientID
          contextchannelID
          sessionID
          nlpstepID
          nlpmodelversionID
          inputnlpoutputID
          key
          outputType
          languageID
          value
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      modelVersionType
      checkpointKey
      checkpointStorageType
      inputlanguageID
      inputLanguage {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      outputlanguageID
      outputLanguage {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      inputParameters {
        includeSpeakerInInput
        parseSpeakerFromOutput
        batchSize
        maxInputChunkLength
        inputChunkOverlapTokens
        outputChunkOverlapTokens
        outputChunkOverlapDiscardLastTokens
        truncateInput
        maxRecursionDepth
        maxRecursiveOutputLength
        allowConcatenatedOutput
        badGenerationResampleTries
        inputPrefix
        inputSuffix
        outputStartWith
        outputSeperators
        returnNMostFrequentOutputs
      }
      inferenceParameters {
        useCache
        maxNewTokens
        minNewTokens
        earlyStopping
        doSample
        numBeams
        penaltyAlpha
        temperature
        topK
        topP
        diversityPenalty
        lengthPenalty
        exponentialDecayLengthPenaltyStartIndex
        exponentialDecayLengthPenaltyDecayFactor
        repetitionPenalty
        encoderRepetitionPenalty
        noRepeatNgramSize
        encoderNoRepeatNgramSize
        forceWords
        badWords
        suppressTokens
      }
      modelParameters {
        hasQuantizedWeights
        skipQuantizeLayers
        gptqWbits
        gptqGroupsize
        loadIn8bit
        loadIn8bitThreshold
        loadIn8bitSkipModules
        torchDtype
        fromTf
        fromFlax
        ignoreMismatchedSizes
      }
      openAIParameters {
        endpoint
        model
        temperature
        maxTokens
        topP
        frequencyPenalty
        presencePenalty
        stop
      }
      outputType
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteNLPModelVersion = /* GraphQL */ `
  mutation DeleteNLPModelVersion(
    $input: DeleteNLPModelVersionInput!
    $condition: ModelNLPModelVersionConditionInput
  ) {
    deleteNLPModelVersion(input: $input, condition: $condition) {
      id
      createdAt
      allowedCognitoGroups
      name
      HFModelType
      parentmodelID
      ParentModel {
        id
        createdAt
        allowedCognitoGroups
        name
        HFModelType
        parentmodelID
        ParentModel {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        childModels {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        NLPOutputs {
          nextToken
          startedAt
        }
        modelVersionType
        checkpointKey
        checkpointStorageType
        inputlanguageID
        inputLanguage {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        outputlanguageID
        outputLanguage {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        inputParameters {
          includeSpeakerInInput
          parseSpeakerFromOutput
          batchSize
          maxInputChunkLength
          inputChunkOverlapTokens
          outputChunkOverlapTokens
          outputChunkOverlapDiscardLastTokens
          truncateInput
          maxRecursionDepth
          maxRecursiveOutputLength
          allowConcatenatedOutput
          badGenerationResampleTries
          inputPrefix
          inputSuffix
          outputStartWith
          outputSeperators
          returnNMostFrequentOutputs
        }
        inferenceParameters {
          useCache
          maxNewTokens
          minNewTokens
          earlyStopping
          doSample
          numBeams
          penaltyAlpha
          temperature
          topK
          topP
          diversityPenalty
          lengthPenalty
          exponentialDecayLengthPenaltyStartIndex
          exponentialDecayLengthPenaltyDecayFactor
          repetitionPenalty
          encoderRepetitionPenalty
          noRepeatNgramSize
          encoderNoRepeatNgramSize
          forceWords
          badWords
          suppressTokens
        }
        modelParameters {
          hasQuantizedWeights
          skipQuantizeLayers
          gptqWbits
          gptqGroupsize
          loadIn8bit
          loadIn8bitThreshold
          loadIn8bitSkipModules
          torchDtype
          fromTf
          fromFlax
          ignoreMismatchedSizes
        }
        openAIParameters {
          endpoint
          model
          temperature
          maxTokens
          topP
          frequencyPenalty
          presencePenalty
          stop
        }
        outputType
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      childModels {
        items {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      NLPSteps {
        items {
          id
          createdAt
          allowedCognitoGroups
          enabled
          clientID
          contextchannelID
          nlpmodelversionID
          name
          outputKey
          inputstepID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      NLPOutputs {
        items {
          id
          createdAt
          allowedCognitoGroups
          clientID
          contextchannelID
          sessionID
          nlpstepID
          nlpmodelversionID
          inputnlpoutputID
          key
          outputType
          languageID
          value
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      modelVersionType
      checkpointKey
      checkpointStorageType
      inputlanguageID
      inputLanguage {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      outputlanguageID
      outputLanguage {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      inputParameters {
        includeSpeakerInInput
        parseSpeakerFromOutput
        batchSize
        maxInputChunkLength
        inputChunkOverlapTokens
        outputChunkOverlapTokens
        outputChunkOverlapDiscardLastTokens
        truncateInput
        maxRecursionDepth
        maxRecursiveOutputLength
        allowConcatenatedOutput
        badGenerationResampleTries
        inputPrefix
        inputSuffix
        outputStartWith
        outputSeperators
        returnNMostFrequentOutputs
      }
      inferenceParameters {
        useCache
        maxNewTokens
        minNewTokens
        earlyStopping
        doSample
        numBeams
        penaltyAlpha
        temperature
        topK
        topP
        diversityPenalty
        lengthPenalty
        exponentialDecayLengthPenaltyStartIndex
        exponentialDecayLengthPenaltyDecayFactor
        repetitionPenalty
        encoderRepetitionPenalty
        noRepeatNgramSize
        encoderNoRepeatNgramSize
        forceWords
        badWords
        suppressTokens
      }
      modelParameters {
        hasQuantizedWeights
        skipQuantizeLayers
        gptqWbits
        gptqGroupsize
        loadIn8bit
        loadIn8bitThreshold
        loadIn8bitSkipModules
        torchDtype
        fromTf
        fromFlax
        ignoreMismatchedSizes
      }
      openAIParameters {
        endpoint
        model
        temperature
        maxTokens
        topP
        frequencyPenalty
        presencePenalty
        stop
      }
      outputType
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createNLPStep = /* GraphQL */ `
  mutation CreateNLPStep(
    $input: CreateNLPStepInput!
    $condition: ModelNLPStepConditionInput
  ) {
    createNLPStep(input: $input, condition: $condition) {
      id
      createdAt
      allowedCognitoGroups
      enabled
      clientID
      contextchannelID
      Contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nlpmodelversionID
      NLPModelVersion {
        id
        createdAt
        allowedCognitoGroups
        name
        HFModelType
        parentmodelID
        ParentModel {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        childModels {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        NLPOutputs {
          nextToken
          startedAt
        }
        modelVersionType
        checkpointKey
        checkpointStorageType
        inputlanguageID
        inputLanguage {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        outputlanguageID
        outputLanguage {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        inputParameters {
          includeSpeakerInInput
          parseSpeakerFromOutput
          batchSize
          maxInputChunkLength
          inputChunkOverlapTokens
          outputChunkOverlapTokens
          outputChunkOverlapDiscardLastTokens
          truncateInput
          maxRecursionDepth
          maxRecursiveOutputLength
          allowConcatenatedOutput
          badGenerationResampleTries
          inputPrefix
          inputSuffix
          outputStartWith
          outputSeperators
          returnNMostFrequentOutputs
        }
        inferenceParameters {
          useCache
          maxNewTokens
          minNewTokens
          earlyStopping
          doSample
          numBeams
          penaltyAlpha
          temperature
          topK
          topP
          diversityPenalty
          lengthPenalty
          exponentialDecayLengthPenaltyStartIndex
          exponentialDecayLengthPenaltyDecayFactor
          repetitionPenalty
          encoderRepetitionPenalty
          noRepeatNgramSize
          encoderNoRepeatNgramSize
          forceWords
          badWords
          suppressTokens
        }
        modelParameters {
          hasQuantizedWeights
          skipQuantizeLayers
          gptqWbits
          gptqGroupsize
          loadIn8bit
          loadIn8bitThreshold
          loadIn8bitSkipModules
          torchDtype
          fromTf
          fromFlax
          ignoreMismatchedSizes
        }
        openAIParameters {
          endpoint
          model
          temperature
          maxTokens
          topP
          frequencyPenalty
          presencePenalty
          stop
        }
        outputType
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      name
      outputKey
      outputLanguages {
        items {
          id
          createdAt
          formality
          nlpstepID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      NLPOutputs {
        items {
          id
          createdAt
          allowedCognitoGroups
          clientID
          contextchannelID
          sessionID
          nlpstepID
          nlpmodelversionID
          inputnlpoutputID
          key
          outputType
          languageID
          value
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      inputstepID
      InputStep {
        id
        createdAt
        allowedCognitoGroups
        enabled
        clientID
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nlpmodelversionID
        NLPModelVersion {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        name
        outputKey
        outputLanguages {
          nextToken
        }
        NLPOutputs {
          nextToken
          startedAt
        }
        inputstepID
        InputStep {
          id
          createdAt
          allowedCognitoGroups
          enabled
          clientID
          contextchannelID
          nlpmodelversionID
          name
          outputKey
          inputstepID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        OutputSteps {
          nextToken
          startedAt
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      OutputSteps {
        items {
          id
          createdAt
          allowedCognitoGroups
          enabled
          clientID
          contextchannelID
          nlpmodelversionID
          name
          outputKey
          inputstepID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateNLPStep = /* GraphQL */ `
  mutation UpdateNLPStep(
    $input: UpdateNLPStepInput!
    $condition: ModelNLPStepConditionInput
  ) {
    updateNLPStep(input: $input, condition: $condition) {
      id
      createdAt
      allowedCognitoGroups
      enabled
      clientID
      contextchannelID
      Contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nlpmodelversionID
      NLPModelVersion {
        id
        createdAt
        allowedCognitoGroups
        name
        HFModelType
        parentmodelID
        ParentModel {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        childModels {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        NLPOutputs {
          nextToken
          startedAt
        }
        modelVersionType
        checkpointKey
        checkpointStorageType
        inputlanguageID
        inputLanguage {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        outputlanguageID
        outputLanguage {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        inputParameters {
          includeSpeakerInInput
          parseSpeakerFromOutput
          batchSize
          maxInputChunkLength
          inputChunkOverlapTokens
          outputChunkOverlapTokens
          outputChunkOverlapDiscardLastTokens
          truncateInput
          maxRecursionDepth
          maxRecursiveOutputLength
          allowConcatenatedOutput
          badGenerationResampleTries
          inputPrefix
          inputSuffix
          outputStartWith
          outputSeperators
          returnNMostFrequentOutputs
        }
        inferenceParameters {
          useCache
          maxNewTokens
          minNewTokens
          earlyStopping
          doSample
          numBeams
          penaltyAlpha
          temperature
          topK
          topP
          diversityPenalty
          lengthPenalty
          exponentialDecayLengthPenaltyStartIndex
          exponentialDecayLengthPenaltyDecayFactor
          repetitionPenalty
          encoderRepetitionPenalty
          noRepeatNgramSize
          encoderNoRepeatNgramSize
          forceWords
          badWords
          suppressTokens
        }
        modelParameters {
          hasQuantizedWeights
          skipQuantizeLayers
          gptqWbits
          gptqGroupsize
          loadIn8bit
          loadIn8bitThreshold
          loadIn8bitSkipModules
          torchDtype
          fromTf
          fromFlax
          ignoreMismatchedSizes
        }
        openAIParameters {
          endpoint
          model
          temperature
          maxTokens
          topP
          frequencyPenalty
          presencePenalty
          stop
        }
        outputType
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      name
      outputKey
      outputLanguages {
        items {
          id
          createdAt
          formality
          nlpstepID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      NLPOutputs {
        items {
          id
          createdAt
          allowedCognitoGroups
          clientID
          contextchannelID
          sessionID
          nlpstepID
          nlpmodelversionID
          inputnlpoutputID
          key
          outputType
          languageID
          value
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      inputstepID
      InputStep {
        id
        createdAt
        allowedCognitoGroups
        enabled
        clientID
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nlpmodelversionID
        NLPModelVersion {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        name
        outputKey
        outputLanguages {
          nextToken
        }
        NLPOutputs {
          nextToken
          startedAt
        }
        inputstepID
        InputStep {
          id
          createdAt
          allowedCognitoGroups
          enabled
          clientID
          contextchannelID
          nlpmodelversionID
          name
          outputKey
          inputstepID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        OutputSteps {
          nextToken
          startedAt
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      OutputSteps {
        items {
          id
          createdAt
          allowedCognitoGroups
          enabled
          clientID
          contextchannelID
          nlpmodelversionID
          name
          outputKey
          inputstepID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteNLPStep = /* GraphQL */ `
  mutation DeleteNLPStep(
    $input: DeleteNLPStepInput!
    $condition: ModelNLPStepConditionInput
  ) {
    deleteNLPStep(input: $input, condition: $condition) {
      id
      createdAt
      allowedCognitoGroups
      enabled
      clientID
      contextchannelID
      Contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nlpmodelversionID
      NLPModelVersion {
        id
        createdAt
        allowedCognitoGroups
        name
        HFModelType
        parentmodelID
        ParentModel {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        childModels {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        NLPOutputs {
          nextToken
          startedAt
        }
        modelVersionType
        checkpointKey
        checkpointStorageType
        inputlanguageID
        inputLanguage {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        outputlanguageID
        outputLanguage {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        inputParameters {
          includeSpeakerInInput
          parseSpeakerFromOutput
          batchSize
          maxInputChunkLength
          inputChunkOverlapTokens
          outputChunkOverlapTokens
          outputChunkOverlapDiscardLastTokens
          truncateInput
          maxRecursionDepth
          maxRecursiveOutputLength
          allowConcatenatedOutput
          badGenerationResampleTries
          inputPrefix
          inputSuffix
          outputStartWith
          outputSeperators
          returnNMostFrequentOutputs
        }
        inferenceParameters {
          useCache
          maxNewTokens
          minNewTokens
          earlyStopping
          doSample
          numBeams
          penaltyAlpha
          temperature
          topK
          topP
          diversityPenalty
          lengthPenalty
          exponentialDecayLengthPenaltyStartIndex
          exponentialDecayLengthPenaltyDecayFactor
          repetitionPenalty
          encoderRepetitionPenalty
          noRepeatNgramSize
          encoderNoRepeatNgramSize
          forceWords
          badWords
          suppressTokens
        }
        modelParameters {
          hasQuantizedWeights
          skipQuantizeLayers
          gptqWbits
          gptqGroupsize
          loadIn8bit
          loadIn8bitThreshold
          loadIn8bitSkipModules
          torchDtype
          fromTf
          fromFlax
          ignoreMismatchedSizes
        }
        openAIParameters {
          endpoint
          model
          temperature
          maxTokens
          topP
          frequencyPenalty
          presencePenalty
          stop
        }
        outputType
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      name
      outputKey
      outputLanguages {
        items {
          id
          createdAt
          formality
          nlpstepID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      NLPOutputs {
        items {
          id
          createdAt
          allowedCognitoGroups
          clientID
          contextchannelID
          sessionID
          nlpstepID
          nlpmodelversionID
          inputnlpoutputID
          key
          outputType
          languageID
          value
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      inputstepID
      InputStep {
        id
        createdAt
        allowedCognitoGroups
        enabled
        clientID
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nlpmodelversionID
        NLPModelVersion {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        name
        outputKey
        outputLanguages {
          nextToken
        }
        NLPOutputs {
          nextToken
          startedAt
        }
        inputstepID
        InputStep {
          id
          createdAt
          allowedCognitoGroups
          enabled
          clientID
          contextchannelID
          nlpmodelversionID
          name
          outputKey
          inputstepID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        OutputSteps {
          nextToken
          startedAt
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      OutputSteps {
        items {
          id
          createdAt
          allowedCognitoGroups
          enabled
          clientID
          contextchannelID
          nlpmodelversionID
          name
          outputKey
          inputstepID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createNLPStepLanguages = /* GraphQL */ `
  mutation CreateNLPStepLanguages(
    $input: CreateNLPStepLanguagesInput!
    $condition: ModelNLPStepLanguagesConditionInput
  ) {
    createNLPStepLanguages(input: $input, condition: $condition) {
      id
      createdAt
      formality
      nlpstepID
      nlpstep {
        id
        createdAt
        allowedCognitoGroups
        enabled
        clientID
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nlpmodelversionID
        NLPModelVersion {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        name
        outputKey
        outputLanguages {
          nextToken
        }
        NLPOutputs {
          nextToken
          startedAt
        }
        inputstepID
        InputStep {
          id
          createdAt
          allowedCognitoGroups
          enabled
          clientID
          contextchannelID
          nlpmodelversionID
          name
          outputKey
          inputstepID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        OutputSteps {
          nextToken
          startedAt
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languageID
      language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateNLPStepLanguages = /* GraphQL */ `
  mutation UpdateNLPStepLanguages(
    $input: UpdateNLPStepLanguagesInput!
    $condition: ModelNLPStepLanguagesConditionInput
  ) {
    updateNLPStepLanguages(input: $input, condition: $condition) {
      id
      createdAt
      formality
      nlpstepID
      nlpstep {
        id
        createdAt
        allowedCognitoGroups
        enabled
        clientID
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nlpmodelversionID
        NLPModelVersion {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        name
        outputKey
        outputLanguages {
          nextToken
        }
        NLPOutputs {
          nextToken
          startedAt
        }
        inputstepID
        InputStep {
          id
          createdAt
          allowedCognitoGroups
          enabled
          clientID
          contextchannelID
          nlpmodelversionID
          name
          outputKey
          inputstepID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        OutputSteps {
          nextToken
          startedAt
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languageID
      language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteNLPStepLanguages = /* GraphQL */ `
  mutation DeleteNLPStepLanguages(
    $input: DeleteNLPStepLanguagesInput!
    $condition: ModelNLPStepLanguagesConditionInput
  ) {
    deleteNLPStepLanguages(input: $input, condition: $condition) {
      id
      createdAt
      formality
      nlpstepID
      nlpstep {
        id
        createdAt
        allowedCognitoGroups
        enabled
        clientID
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nlpmodelversionID
        NLPModelVersion {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        name
        outputKey
        outputLanguages {
          nextToken
        }
        NLPOutputs {
          nextToken
          startedAt
        }
        inputstepID
        InputStep {
          id
          createdAt
          allowedCognitoGroups
          enabled
          clientID
          contextchannelID
          nlpmodelversionID
          name
          outputKey
          inputstepID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        OutputSteps {
          nextToken
          startedAt
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languageID
      language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createNLPOutput = /* GraphQL */ `
  mutation CreateNLPOutput(
    $input: CreateNLPOutputInput!
    $condition: ModelNLPOutputConditionInput
  ) {
    createNLPOutput(input: $input, condition: $condition) {
      id
      createdAt
      allowedCognitoGroups
      clientID
      contextchannelID
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nlpstepID
      NLPStep {
        id
        createdAt
        allowedCognitoGroups
        enabled
        clientID
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nlpmodelversionID
        NLPModelVersion {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        name
        outputKey
        outputLanguages {
          nextToken
        }
        NLPOutputs {
          nextToken
          startedAt
        }
        inputstepID
        InputStep {
          id
          createdAt
          allowedCognitoGroups
          enabled
          clientID
          contextchannelID
          nlpmodelversionID
          name
          outputKey
          inputstepID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        OutputSteps {
          nextToken
          startedAt
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nlpmodelversionID
      NLPModelVersion {
        id
        createdAt
        allowedCognitoGroups
        name
        HFModelType
        parentmodelID
        ParentModel {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        childModels {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        NLPOutputs {
          nextToken
          startedAt
        }
        modelVersionType
        checkpointKey
        checkpointStorageType
        inputlanguageID
        inputLanguage {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        outputlanguageID
        outputLanguage {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        inputParameters {
          includeSpeakerInInput
          parseSpeakerFromOutput
          batchSize
          maxInputChunkLength
          inputChunkOverlapTokens
          outputChunkOverlapTokens
          outputChunkOverlapDiscardLastTokens
          truncateInput
          maxRecursionDepth
          maxRecursiveOutputLength
          allowConcatenatedOutput
          badGenerationResampleTries
          inputPrefix
          inputSuffix
          outputStartWith
          outputSeperators
          returnNMostFrequentOutputs
        }
        inferenceParameters {
          useCache
          maxNewTokens
          minNewTokens
          earlyStopping
          doSample
          numBeams
          penaltyAlpha
          temperature
          topK
          topP
          diversityPenalty
          lengthPenalty
          exponentialDecayLengthPenaltyStartIndex
          exponentialDecayLengthPenaltyDecayFactor
          repetitionPenalty
          encoderRepetitionPenalty
          noRepeatNgramSize
          encoderNoRepeatNgramSize
          forceWords
          badWords
          suppressTokens
        }
        modelParameters {
          hasQuantizedWeights
          skipQuantizeLayers
          gptqWbits
          gptqGroupsize
          loadIn8bit
          loadIn8bitThreshold
          loadIn8bitSkipModules
          torchDtype
          fromTf
          fromFlax
          ignoreMismatchedSizes
        }
        openAIParameters {
          endpoint
          model
          temperature
          maxTokens
          topP
          frequencyPenalty
          presencePenalty
          stop
        }
        outputType
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      inputnlpoutputID
      inputNLPOutput {
        id
        createdAt
        allowedCognitoGroups
        clientID
        contextchannelID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nlpstepID
        NLPStep {
          id
          createdAt
          allowedCognitoGroups
          enabled
          clientID
          contextchannelID
          nlpmodelversionID
          name
          outputKey
          inputstepID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nlpmodelversionID
        NLPModelVersion {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        inputnlpoutputID
        inputNLPOutput {
          id
          createdAt
          allowedCognitoGroups
          clientID
          contextchannelID
          sessionID
          nlpstepID
          nlpmodelversionID
          inputnlpoutputID
          key
          outputType
          languageID
          value
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        outputNLPOutputs {
          nextToken
          startedAt
        }
        key
        outputType
        languageID
        language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        value
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      outputNLPOutputs {
        items {
          id
          createdAt
          allowedCognitoGroups
          clientID
          contextchannelID
          sessionID
          nlpstepID
          nlpmodelversionID
          inputnlpoutputID
          key
          outputType
          languageID
          value
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      key
      outputType
      languageID
      language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      value
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateNLPOutput = /* GraphQL */ `
  mutation UpdateNLPOutput(
    $input: UpdateNLPOutputInput!
    $condition: ModelNLPOutputConditionInput
  ) {
    updateNLPOutput(input: $input, condition: $condition) {
      id
      createdAt
      allowedCognitoGroups
      clientID
      contextchannelID
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nlpstepID
      NLPStep {
        id
        createdAt
        allowedCognitoGroups
        enabled
        clientID
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nlpmodelversionID
        NLPModelVersion {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        name
        outputKey
        outputLanguages {
          nextToken
        }
        NLPOutputs {
          nextToken
          startedAt
        }
        inputstepID
        InputStep {
          id
          createdAt
          allowedCognitoGroups
          enabled
          clientID
          contextchannelID
          nlpmodelversionID
          name
          outputKey
          inputstepID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        OutputSteps {
          nextToken
          startedAt
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nlpmodelversionID
      NLPModelVersion {
        id
        createdAt
        allowedCognitoGroups
        name
        HFModelType
        parentmodelID
        ParentModel {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        childModels {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        NLPOutputs {
          nextToken
          startedAt
        }
        modelVersionType
        checkpointKey
        checkpointStorageType
        inputlanguageID
        inputLanguage {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        outputlanguageID
        outputLanguage {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        inputParameters {
          includeSpeakerInInput
          parseSpeakerFromOutput
          batchSize
          maxInputChunkLength
          inputChunkOverlapTokens
          outputChunkOverlapTokens
          outputChunkOverlapDiscardLastTokens
          truncateInput
          maxRecursionDepth
          maxRecursiveOutputLength
          allowConcatenatedOutput
          badGenerationResampleTries
          inputPrefix
          inputSuffix
          outputStartWith
          outputSeperators
          returnNMostFrequentOutputs
        }
        inferenceParameters {
          useCache
          maxNewTokens
          minNewTokens
          earlyStopping
          doSample
          numBeams
          penaltyAlpha
          temperature
          topK
          topP
          diversityPenalty
          lengthPenalty
          exponentialDecayLengthPenaltyStartIndex
          exponentialDecayLengthPenaltyDecayFactor
          repetitionPenalty
          encoderRepetitionPenalty
          noRepeatNgramSize
          encoderNoRepeatNgramSize
          forceWords
          badWords
          suppressTokens
        }
        modelParameters {
          hasQuantizedWeights
          skipQuantizeLayers
          gptqWbits
          gptqGroupsize
          loadIn8bit
          loadIn8bitThreshold
          loadIn8bitSkipModules
          torchDtype
          fromTf
          fromFlax
          ignoreMismatchedSizes
        }
        openAIParameters {
          endpoint
          model
          temperature
          maxTokens
          topP
          frequencyPenalty
          presencePenalty
          stop
        }
        outputType
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      inputnlpoutputID
      inputNLPOutput {
        id
        createdAt
        allowedCognitoGroups
        clientID
        contextchannelID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nlpstepID
        NLPStep {
          id
          createdAt
          allowedCognitoGroups
          enabled
          clientID
          contextchannelID
          nlpmodelversionID
          name
          outputKey
          inputstepID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nlpmodelversionID
        NLPModelVersion {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        inputnlpoutputID
        inputNLPOutput {
          id
          createdAt
          allowedCognitoGroups
          clientID
          contextchannelID
          sessionID
          nlpstepID
          nlpmodelversionID
          inputnlpoutputID
          key
          outputType
          languageID
          value
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        outputNLPOutputs {
          nextToken
          startedAt
        }
        key
        outputType
        languageID
        language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        value
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      outputNLPOutputs {
        items {
          id
          createdAt
          allowedCognitoGroups
          clientID
          contextchannelID
          sessionID
          nlpstepID
          nlpmodelversionID
          inputnlpoutputID
          key
          outputType
          languageID
          value
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      key
      outputType
      languageID
      language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      value
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteNLPOutput = /* GraphQL */ `
  mutation DeleteNLPOutput(
    $input: DeleteNLPOutputInput!
    $condition: ModelNLPOutputConditionInput
  ) {
    deleteNLPOutput(input: $input, condition: $condition) {
      id
      createdAt
      allowedCognitoGroups
      clientID
      contextchannelID
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nlpstepID
      NLPStep {
        id
        createdAt
        allowedCognitoGroups
        enabled
        clientID
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nlpmodelversionID
        NLPModelVersion {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        name
        outputKey
        outputLanguages {
          nextToken
        }
        NLPOutputs {
          nextToken
          startedAt
        }
        inputstepID
        InputStep {
          id
          createdAt
          allowedCognitoGroups
          enabled
          clientID
          contextchannelID
          nlpmodelversionID
          name
          outputKey
          inputstepID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        OutputSteps {
          nextToken
          startedAt
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nlpmodelversionID
      NLPModelVersion {
        id
        createdAt
        allowedCognitoGroups
        name
        HFModelType
        parentmodelID
        ParentModel {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        childModels {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        NLPOutputs {
          nextToken
          startedAt
        }
        modelVersionType
        checkpointKey
        checkpointStorageType
        inputlanguageID
        inputLanguage {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        outputlanguageID
        outputLanguage {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        inputParameters {
          includeSpeakerInInput
          parseSpeakerFromOutput
          batchSize
          maxInputChunkLength
          inputChunkOverlapTokens
          outputChunkOverlapTokens
          outputChunkOverlapDiscardLastTokens
          truncateInput
          maxRecursionDepth
          maxRecursiveOutputLength
          allowConcatenatedOutput
          badGenerationResampleTries
          inputPrefix
          inputSuffix
          outputStartWith
          outputSeperators
          returnNMostFrequentOutputs
        }
        inferenceParameters {
          useCache
          maxNewTokens
          minNewTokens
          earlyStopping
          doSample
          numBeams
          penaltyAlpha
          temperature
          topK
          topP
          diversityPenalty
          lengthPenalty
          exponentialDecayLengthPenaltyStartIndex
          exponentialDecayLengthPenaltyDecayFactor
          repetitionPenalty
          encoderRepetitionPenalty
          noRepeatNgramSize
          encoderNoRepeatNgramSize
          forceWords
          badWords
          suppressTokens
        }
        modelParameters {
          hasQuantizedWeights
          skipQuantizeLayers
          gptqWbits
          gptqGroupsize
          loadIn8bit
          loadIn8bitThreshold
          loadIn8bitSkipModules
          torchDtype
          fromTf
          fromFlax
          ignoreMismatchedSizes
        }
        openAIParameters {
          endpoint
          model
          temperature
          maxTokens
          topP
          frequencyPenalty
          presencePenalty
          stop
        }
        outputType
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      inputnlpoutputID
      inputNLPOutput {
        id
        createdAt
        allowedCognitoGroups
        clientID
        contextchannelID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nlpstepID
        NLPStep {
          id
          createdAt
          allowedCognitoGroups
          enabled
          clientID
          contextchannelID
          nlpmodelversionID
          name
          outputKey
          inputstepID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nlpmodelversionID
        NLPModelVersion {
          id
          createdAt
          allowedCognitoGroups
          name
          HFModelType
          parentmodelID
          modelVersionType
          checkpointKey
          checkpointStorageType
          inputlanguageID
          outputlanguageID
          outputType
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        inputnlpoutputID
        inputNLPOutput {
          id
          createdAt
          allowedCognitoGroups
          clientID
          contextchannelID
          sessionID
          nlpstepID
          nlpmodelversionID
          inputnlpoutputID
          key
          outputType
          languageID
          value
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        outputNLPOutputs {
          nextToken
          startedAt
        }
        key
        outputType
        languageID
        language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        value
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      outputNLPOutputs {
        items {
          id
          createdAt
          allowedCognitoGroups
          clientID
          contextchannelID
          sessionID
          nlpstepID
          nlpmodelversionID
          inputnlpoutputID
          key
          outputType
          languageID
          value
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      key
      outputType
      languageID
      language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      value
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createClusteringModuleOutput = /* GraphQL */ `
  mutation CreateClusteringModuleOutput(
    $input: CreateClusteringModuleOutputInput!
    $condition: ModelClusteringModuleOutputConditionInput
  ) {
    createClusteringModuleOutput(input: $input, condition: $condition) {
      id
      createdAt
      allowedCognitoGroups
      clientID
      contextchannelID
      Contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      key
      leafIDs
      linkageMatrixS3Url
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateClusteringModuleOutput = /* GraphQL */ `
  mutation UpdateClusteringModuleOutput(
    $input: UpdateClusteringModuleOutputInput!
    $condition: ModelClusteringModuleOutputConditionInput
  ) {
    updateClusteringModuleOutput(input: $input, condition: $condition) {
      id
      createdAt
      allowedCognitoGroups
      clientID
      contextchannelID
      Contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      key
      leafIDs
      linkageMatrixS3Url
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteClusteringModuleOutput = /* GraphQL */ `
  mutation DeleteClusteringModuleOutput(
    $input: DeleteClusteringModuleOutputInput!
    $condition: ModelClusteringModuleOutputConditionInput
  ) {
    deleteClusteringModuleOutput(input: $input, condition: $condition) {
      id
      createdAt
      allowedCognitoGroups
      clientID
      contextchannelID
      Contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      key
      leafIDs
      linkageMatrixS3Url
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createSessionSpeakers = /* GraphQL */ `
  mutation CreateSessionSpeakers(
    $input: CreateSessionSpeakersInput!
    $condition: ModelSessionSpeakersConditionInput
  ) {
    createSessionSpeakers(input: $input, condition: $condition) {
      id
      createdAt
      isDefaultSpeaker
      sessionID
      session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      speakerID
      speaker {
        id
        allowedCognitoGroups
        firstName
        infix
        lastName
        gender
        Subscriptions {
          nextToken
          startedAt
        }
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Languages {
          nextToken
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        LanguageLabels {
          nextToken
          startedAt
        }
        userID
        User {
          id
          teamGroup
          isActive
          email
          needsEmailChange
          firstName
          infix
          lastName
          avatarS3Url
          speakerID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateSessionSpeakers = /* GraphQL */ `
  mutation UpdateSessionSpeakers(
    $input: UpdateSessionSpeakersInput!
    $condition: ModelSessionSpeakersConditionInput
  ) {
    updateSessionSpeakers(input: $input, condition: $condition) {
      id
      createdAt
      isDefaultSpeaker
      sessionID
      session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      speakerID
      speaker {
        id
        allowedCognitoGroups
        firstName
        infix
        lastName
        gender
        Subscriptions {
          nextToken
          startedAt
        }
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Languages {
          nextToken
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        LanguageLabels {
          nextToken
          startedAt
        }
        userID
        User {
          id
          teamGroup
          isActive
          email
          needsEmailChange
          firstName
          infix
          lastName
          avatarS3Url
          speakerID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteSessionSpeakers = /* GraphQL */ `
  mutation DeleteSessionSpeakers(
    $input: DeleteSessionSpeakersInput!
    $condition: ModelSessionSpeakersConditionInput
  ) {
    deleteSessionSpeakers(input: $input, condition: $condition) {
      id
      createdAt
      isDefaultSpeaker
      sessionID
      session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      speakerID
      speaker {
        id
        allowedCognitoGroups
        firstName
        infix
        lastName
        gender
        Subscriptions {
          nextToken
          startedAt
        }
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Languages {
          nextToken
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        LanguageLabels {
          nextToken
          startedAt
        }
        userID
        User {
          id
          teamGroup
          isActive
          email
          needsEmailChange
          firstName
          infix
          lastName
          avatarS3Url
          speakerID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createSessionLanguages = /* GraphQL */ `
  mutation CreateSessionLanguages(
    $input: CreateSessionLanguagesInput!
    $condition: ModelSessionLanguagesConditionInput
  ) {
    createSessionLanguages(input: $input, condition: $condition) {
      id
      createdAt
      isDefaultLanguage
      sessionID
      session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languageID
      language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      dialects {
        items {
          id
          createdAt
          isDefaultLanguageDialect
          sessionlanguageID
          languagedialectID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateSessionLanguages = /* GraphQL */ `
  mutation UpdateSessionLanguages(
    $input: UpdateSessionLanguagesInput!
    $condition: ModelSessionLanguagesConditionInput
  ) {
    updateSessionLanguages(input: $input, condition: $condition) {
      id
      createdAt
      isDefaultLanguage
      sessionID
      session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languageID
      language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      dialects {
        items {
          id
          createdAt
          isDefaultLanguageDialect
          sessionlanguageID
          languagedialectID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteSessionLanguages = /* GraphQL */ `
  mutation DeleteSessionLanguages(
    $input: DeleteSessionLanguagesInput!
    $condition: ModelSessionLanguagesConditionInput
  ) {
    deleteSessionLanguages(input: $input, condition: $condition) {
      id
      createdAt
      isDefaultLanguage
      sessionID
      session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languageID
      language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      dialects {
        items {
          id
          createdAt
          isDefaultLanguageDialect
          sessionlanguageID
          languagedialectID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createSessionLanguageLanguageDialects = /* GraphQL */ `
  mutation CreateSessionLanguageLanguageDialects(
    $input: CreateSessionLanguageLanguageDialectsInput!
    $condition: ModelSessionLanguageLanguageDialectsConditionInput
  ) {
    createSessionLanguageLanguageDialects(
      input: $input
      condition: $condition
    ) {
      id
      createdAt
      isDefaultLanguageDialect
      sessionlanguageID
      sessionlanguage {
        id
        createdAt
        isDefaultLanguage
        sessionID
        session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        languageID
        language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        dialects {
          nextToken
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languagedialectID
      languagedialect {
        id
        name
        ISO_639_2_dialect
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateSessionLanguageLanguageDialects = /* GraphQL */ `
  mutation UpdateSessionLanguageLanguageDialects(
    $input: UpdateSessionLanguageLanguageDialectsInput!
    $condition: ModelSessionLanguageLanguageDialectsConditionInput
  ) {
    updateSessionLanguageLanguageDialects(
      input: $input
      condition: $condition
    ) {
      id
      createdAt
      isDefaultLanguageDialect
      sessionlanguageID
      sessionlanguage {
        id
        createdAt
        isDefaultLanguage
        sessionID
        session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        languageID
        language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        dialects {
          nextToken
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languagedialectID
      languagedialect {
        id
        name
        ISO_639_2_dialect
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteSessionLanguageLanguageDialects = /* GraphQL */ `
  mutation DeleteSessionLanguageLanguageDialects(
    $input: DeleteSessionLanguageLanguageDialectsInput!
    $condition: ModelSessionLanguageLanguageDialectsConditionInput
  ) {
    deleteSessionLanguageLanguageDialects(
      input: $input
      condition: $condition
    ) {
      id
      createdAt
      isDefaultLanguageDialect
      sessionlanguageID
      sessionlanguage {
        id
        createdAt
        isDefaultLanguage
        sessionID
        session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        languageID
        language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        dialects {
          nextToken
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languagedialectID
      languagedialect {
        id
        name
        ISO_639_2_dialect
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createMetadata = /* GraphQL */ `
  mutation CreateMetadata(
    $input: CreateMetadataInput!
    $condition: ModelMetadataConditionInput
  ) {
    createMetadata(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      metadataS3Key
      durationSeconds
      metadataStatus
      clientID
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateMetadata = /* GraphQL */ `
  mutation UpdateMetadata(
    $input: UpdateMetadataInput!
    $condition: ModelMetadataConditionInput
  ) {
    updateMetadata(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      metadataS3Key
      durationSeconds
      metadataStatus
      clientID
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteMetadata = /* GraphQL */ `
  mutation DeleteMetadata(
    $input: DeleteMetadataInput!
    $condition: ModelMetadataConditionInput
  ) {
    deleteMetadata(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      metadataS3Key
      durationSeconds
      metadataStatus
      clientID
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createAudio = /* GraphQL */ `
  mutation CreateAudio(
    $input: CreateAudioInput!
    $condition: ModelAudioConditionInput
  ) {
    createAudio(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      uncompressedAudioS3Key
      compressedAudioS3Key
      waveformDataS3Key
      audioStatus
      clientID
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateAudio = /* GraphQL */ `
  mutation UpdateAudio(
    $input: UpdateAudioInput!
    $condition: ModelAudioConditionInput
  ) {
    updateAudio(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      uncompressedAudioS3Key
      compressedAudioS3Key
      waveformDataS3Key
      audioStatus
      clientID
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteAudio = /* GraphQL */ `
  mutation DeleteAudio(
    $input: DeleteAudioInput!
    $condition: ModelAudioConditionInput
  ) {
    deleteAudio(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      uncompressedAudioS3Key
      compressedAudioS3Key
      waveformDataS3Key
      audioStatus
      clientID
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createVideo = /* GraphQL */ `
  mutation CreateVideo(
    $input: CreateVideoInput!
    $condition: ModelVideoConditionInput
  ) {
    createVideo(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      compressedVideoS3Key
      videoStatus
      clientID
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateVideo = /* GraphQL */ `
  mutation UpdateVideo(
    $input: UpdateVideoInput!
    $condition: ModelVideoConditionInput
  ) {
    updateVideo(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      compressedVideoS3Key
      videoStatus
      clientID
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteVideo = /* GraphQL */ `
  mutation DeleteVideo(
    $input: DeleteVideoInput!
    $condition: ModelVideoConditionInput
  ) {
    deleteVideo(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      compressedVideoS3Key
      videoStatus
      clientID
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createAutoTranscript = /* GraphQL */ `
  mutation CreateAutoTranscript(
    $input: CreateAutoTranscriptInput!
    $condition: ModelAutoTranscriptConditionInput
  ) {
    createAutoTranscript(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      speechmodelID
      SpeechModel {
        id
        name
        description
        s3ImageUrl
        allowedCognitoGroups
        provider
        connectionString
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        languagedialectID
        LanguageDialect {
          id
          name
          ISO_639_2_dialect
          languageID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      transcriptSourceS3Key
      transcriptStandardizedS3Key
      transcriptTranslationS3Keys
      transcriptionStatus
      exportPlainTextS3Key
      exportJsonS3Key
      subtitlesSrtS3Key
      subtitlesVttS3Key
      subtitleStatus
      diarizationS3Key
      summaryS3Key
      categoriesJson
      autotranscriptstatsID
      AutoTranscriptStats {
        id
        allowedCognitoGroups
        unknowns
        wordCount
        unknownPercentage
        globalConfidence
        knownConfidence
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        sessionID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      clientID
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateAutoTranscript = /* GraphQL */ `
  mutation UpdateAutoTranscript(
    $input: UpdateAutoTranscriptInput!
    $condition: ModelAutoTranscriptConditionInput
  ) {
    updateAutoTranscript(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      speechmodelID
      SpeechModel {
        id
        name
        description
        s3ImageUrl
        allowedCognitoGroups
        provider
        connectionString
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        languagedialectID
        LanguageDialect {
          id
          name
          ISO_639_2_dialect
          languageID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      transcriptSourceS3Key
      transcriptStandardizedS3Key
      transcriptTranslationS3Keys
      transcriptionStatus
      exportPlainTextS3Key
      exportJsonS3Key
      subtitlesSrtS3Key
      subtitlesVttS3Key
      subtitleStatus
      diarizationS3Key
      summaryS3Key
      categoriesJson
      autotranscriptstatsID
      AutoTranscriptStats {
        id
        allowedCognitoGroups
        unknowns
        wordCount
        unknownPercentage
        globalConfidence
        knownConfidence
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        sessionID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      clientID
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteAutoTranscript = /* GraphQL */ `
  mutation DeleteAutoTranscript(
    $input: DeleteAutoTranscriptInput!
    $condition: ModelAutoTranscriptConditionInput
  ) {
    deleteAutoTranscript(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      speechmodelID
      SpeechModel {
        id
        name
        description
        s3ImageUrl
        allowedCognitoGroups
        provider
        connectionString
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        languagedialectID
        LanguageDialect {
          id
          name
          ISO_639_2_dialect
          languageID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      transcriptSourceS3Key
      transcriptStandardizedS3Key
      transcriptTranslationS3Keys
      transcriptionStatus
      exportPlainTextS3Key
      exportJsonS3Key
      subtitlesSrtS3Key
      subtitlesVttS3Key
      subtitleStatus
      diarizationS3Key
      summaryS3Key
      categoriesJson
      autotranscriptstatsID
      AutoTranscriptStats {
        id
        allowedCognitoGroups
        unknowns
        wordCount
        unknownPercentage
        globalConfidence
        knownConfidence
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        sessionID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      clientID
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createGoldTranscript = /* GraphQL */ `
  mutation CreateGoldTranscript(
    $input: CreateGoldTranscriptInput!
    $condition: ModelGoldTranscriptConditionInput
  ) {
    createGoldTranscript(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      validationProgressStatus
      LanguageLabels {
        items {
          id
          allowedCognitoGroups
          createdAt
          submittedAt
          validatedAt
          submitteduserID
          validateduserID
          clientID
          contextchannelID
          sessionID
          goldtranscriptID
          starttime
          endtime
          speakerID
          languageID
          languagedialectID
          content
          contentJson
          sentimentJson
          contentOrigin
          contentJsonOrigin
          sentimentJsonOrigin
          validationStatus
          feedbackMessage
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      transcriptS3Key
      subtitlesSrtS3Key
      subtitlesVttS3Key
      subtitleStatus
      clientID
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateGoldTranscript = /* GraphQL */ `
  mutation UpdateGoldTranscript(
    $input: UpdateGoldTranscriptInput!
    $condition: ModelGoldTranscriptConditionInput
  ) {
    updateGoldTranscript(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      validationProgressStatus
      LanguageLabels {
        items {
          id
          allowedCognitoGroups
          createdAt
          submittedAt
          validatedAt
          submitteduserID
          validateduserID
          clientID
          contextchannelID
          sessionID
          goldtranscriptID
          starttime
          endtime
          speakerID
          languageID
          languagedialectID
          content
          contentJson
          sentimentJson
          contentOrigin
          contentJsonOrigin
          sentimentJsonOrigin
          validationStatus
          feedbackMessage
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      transcriptS3Key
      subtitlesSrtS3Key
      subtitlesVttS3Key
      subtitleStatus
      clientID
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteGoldTranscript = /* GraphQL */ `
  mutation DeleteGoldTranscript(
    $input: DeleteGoldTranscriptInput!
    $condition: ModelGoldTranscriptConditionInput
  ) {
    deleteGoldTranscript(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      validationProgressStatus
      LanguageLabels {
        items {
          id
          allowedCognitoGroups
          createdAt
          submittedAt
          validatedAt
          submitteduserID
          validateduserID
          clientID
          contextchannelID
          sessionID
          goldtranscriptID
          starttime
          endtime
          speakerID
          languageID
          languagedialectID
          content
          contentJson
          sentimentJson
          contentOrigin
          contentJsonOrigin
          sentimentJsonOrigin
          validationStatus
          feedbackMessage
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      transcriptS3Key
      subtitlesSrtS3Key
      subtitlesVttS3Key
      subtitleStatus
      clientID
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createCustomTranscript = /* GraphQL */ `
  mutation CreateCustomTranscript(
    $input: CreateCustomTranscriptInput!
    $condition: ModelCustomTranscriptConditionInput
  ) {
    createCustomTranscript(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      transcriptS3Key
      subtitlesSrtS3Key
      subtitlesVttS3Key
      subtitleStatus
      clientID
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateCustomTranscript = /* GraphQL */ `
  mutation UpdateCustomTranscript(
    $input: UpdateCustomTranscriptInput!
    $condition: ModelCustomTranscriptConditionInput
  ) {
    updateCustomTranscript(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      transcriptS3Key
      subtitlesSrtS3Key
      subtitlesVttS3Key
      subtitleStatus
      clientID
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteCustomTranscript = /* GraphQL */ `
  mutation DeleteCustomTranscript(
    $input: DeleteCustomTranscriptInput!
    $condition: ModelCustomTranscriptConditionInput
  ) {
    deleteCustomTranscript(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      transcriptS3Key
      subtitlesSrtS3Key
      subtitlesVttS3Key
      subtitleStatus
      clientID
      sessionID
      Session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createAutoTranscriptStats = /* GraphQL */ `
  mutation CreateAutoTranscriptStats(
    $input: CreateAutoTranscriptStatsInput!
    $condition: ModelAutoTranscriptStatsConditionInput
  ) {
    createAutoTranscriptStats(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      unknowns
      wordCount
      unknownPercentage
      globalConfidence
      knownConfidence
      autotranscriptID
      AutoTranscript {
        id
        allowedCognitoGroups
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        transcriptSourceS3Key
        transcriptStandardizedS3Key
        transcriptTranslationS3Keys
        transcriptionStatus
        exportPlainTextS3Key
        exportJsonS3Key
        subtitlesSrtS3Key
        subtitlesVttS3Key
        subtitleStatus
        diarizationS3Key
        summaryS3Key
        categoriesJson
        autotranscriptstatsID
        AutoTranscriptStats {
          id
          allowedCognitoGroups
          unknowns
          wordCount
          unknownPercentage
          globalConfidence
          knownConfidence
          autotranscriptID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      clientID
      sessionID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateAutoTranscriptStats = /* GraphQL */ `
  mutation UpdateAutoTranscriptStats(
    $input: UpdateAutoTranscriptStatsInput!
    $condition: ModelAutoTranscriptStatsConditionInput
  ) {
    updateAutoTranscriptStats(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      unknowns
      wordCount
      unknownPercentage
      globalConfidence
      knownConfidence
      autotranscriptID
      AutoTranscript {
        id
        allowedCognitoGroups
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        transcriptSourceS3Key
        transcriptStandardizedS3Key
        transcriptTranslationS3Keys
        transcriptionStatus
        exportPlainTextS3Key
        exportJsonS3Key
        subtitlesSrtS3Key
        subtitlesVttS3Key
        subtitleStatus
        diarizationS3Key
        summaryS3Key
        categoriesJson
        autotranscriptstatsID
        AutoTranscriptStats {
          id
          allowedCognitoGroups
          unknowns
          wordCount
          unknownPercentage
          globalConfidence
          knownConfidence
          autotranscriptID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      clientID
      sessionID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteAutoTranscriptStats = /* GraphQL */ `
  mutation DeleteAutoTranscriptStats(
    $input: DeleteAutoTranscriptStatsInput!
    $condition: ModelAutoTranscriptStatsConditionInput
  ) {
    deleteAutoTranscriptStats(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      unknowns
      wordCount
      unknownPercentage
      globalConfidence
      knownConfidence
      autotranscriptID
      AutoTranscript {
        id
        allowedCognitoGroups
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        transcriptSourceS3Key
        transcriptStandardizedS3Key
        transcriptTranslationS3Keys
        transcriptionStatus
        exportPlainTextS3Key
        exportJsonS3Key
        subtitlesSrtS3Key
        subtitlesVttS3Key
        subtitleStatus
        diarizationS3Key
        summaryS3Key
        categoriesJson
        autotranscriptstatsID
        AutoTranscriptStats {
          id
          allowedCognitoGroups
          unknowns
          wordCount
          unknownPercentage
          globalConfidence
          knownConfidence
          autotranscriptID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      clientID
      sessionID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createSpeechModel = /* GraphQL */ `
  mutation CreateSpeechModel(
    $input: CreateSpeechModelInput!
    $condition: ModelSpeechModelConditionInput
  ) {
    createSpeechModel(input: $input, condition: $condition) {
      id
      name
      description
      s3ImageUrl
      allowedCognitoGroups
      provider
      connectionString
      languageID
      Language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languagedialectID
      LanguageDialect {
        id
        name
        ISO_639_2_dialect
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateSpeechModel = /* GraphQL */ `
  mutation UpdateSpeechModel(
    $input: UpdateSpeechModelInput!
    $condition: ModelSpeechModelConditionInput
  ) {
    updateSpeechModel(input: $input, condition: $condition) {
      id
      name
      description
      s3ImageUrl
      allowedCognitoGroups
      provider
      connectionString
      languageID
      Language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languagedialectID
      LanguageDialect {
        id
        name
        ISO_639_2_dialect
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteSpeechModel = /* GraphQL */ `
  mutation DeleteSpeechModel(
    $input: DeleteSpeechModelInput!
    $condition: ModelSpeechModelConditionInput
  ) {
    deleteSpeechModel(input: $input, condition: $condition) {
      id
      name
      description
      s3ImageUrl
      allowedCognitoGroups
      provider
      connectionString
      languageID
      Language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languagedialectID
      LanguageDialect {
        id
        name
        ISO_639_2_dialect
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createLanguageLabel = /* GraphQL */ `
  mutation CreateLanguageLabel(
    $input: CreateLanguageLabelInput!
    $condition: ModelLanguageLabelConditionInput
  ) {
    createLanguageLabel(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      createdAt
      submittedAt
      validatedAt
      submitteduserID
      submittedUser {
        id
        teamGroup
        isActive
        email
        needsEmailChange
        firstName
        infix
        lastName
        avatarS3Url
        speakerID
        Speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        submittedLanguageLabels {
          nextToken
          startedAt
        }
        validatedLanguageLabels {
          nextToken
          startedAt
        }
        allowedContextchannels {
          nextToken
        }
        ContextchannelSubscriptions {
          nextToken
          startedAt
        }
        SessionSubscriptions {
          nextToken
          startedAt
        }
        SpeakerSubscriptions {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      validateduserID
      validatedUser {
        id
        teamGroup
        isActive
        email
        needsEmailChange
        firstName
        infix
        lastName
        avatarS3Url
        speakerID
        Speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        submittedLanguageLabels {
          nextToken
          startedAt
        }
        validatedLanguageLabels {
          nextToken
          startedAt
        }
        allowedContextchannels {
          nextToken
        }
        ContextchannelSubscriptions {
          nextToken
          startedAt
        }
        SessionSubscriptions {
          nextToken
          startedAt
        }
        SpeakerSubscriptions {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      clientID
      contextchannelID
      sessionID
      goldtranscriptID
      GoldTranscript {
        id
        allowedCognitoGroups
        validationProgressStatus
        LanguageLabels {
          nextToken
          startedAt
        }
        transcriptS3Key
        subtitlesSrtS3Key
        subtitlesVttS3Key
        subtitleStatus
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      starttime
      endtime
      speakerID
      Speaker {
        id
        allowedCognitoGroups
        firstName
        infix
        lastName
        gender
        Subscriptions {
          nextToken
          startedAt
        }
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Languages {
          nextToken
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        LanguageLabels {
          nextToken
          startedAt
        }
        userID
        User {
          id
          teamGroup
          isActive
          email
          needsEmailChange
          firstName
          infix
          lastName
          avatarS3Url
          speakerID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languageID
      Language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languagedialectID
      LanguageDialect {
        id
        name
        ISO_639_2_dialect
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      content
      contentJson
      sentimentJson
      contentOrigin
      contentJsonOrigin
      sentimentJsonOrigin
      validationStatus
      feedbackMessage
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateLanguageLabel = /* GraphQL */ `
  mutation UpdateLanguageLabel(
    $input: UpdateLanguageLabelInput!
    $condition: ModelLanguageLabelConditionInput
  ) {
    updateLanguageLabel(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      createdAt
      submittedAt
      validatedAt
      submitteduserID
      submittedUser {
        id
        teamGroup
        isActive
        email
        needsEmailChange
        firstName
        infix
        lastName
        avatarS3Url
        speakerID
        Speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        submittedLanguageLabels {
          nextToken
          startedAt
        }
        validatedLanguageLabels {
          nextToken
          startedAt
        }
        allowedContextchannels {
          nextToken
        }
        ContextchannelSubscriptions {
          nextToken
          startedAt
        }
        SessionSubscriptions {
          nextToken
          startedAt
        }
        SpeakerSubscriptions {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      validateduserID
      validatedUser {
        id
        teamGroup
        isActive
        email
        needsEmailChange
        firstName
        infix
        lastName
        avatarS3Url
        speakerID
        Speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        submittedLanguageLabels {
          nextToken
          startedAt
        }
        validatedLanguageLabels {
          nextToken
          startedAt
        }
        allowedContextchannels {
          nextToken
        }
        ContextchannelSubscriptions {
          nextToken
          startedAt
        }
        SessionSubscriptions {
          nextToken
          startedAt
        }
        SpeakerSubscriptions {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      clientID
      contextchannelID
      sessionID
      goldtranscriptID
      GoldTranscript {
        id
        allowedCognitoGroups
        validationProgressStatus
        LanguageLabels {
          nextToken
          startedAt
        }
        transcriptS3Key
        subtitlesSrtS3Key
        subtitlesVttS3Key
        subtitleStatus
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      starttime
      endtime
      speakerID
      Speaker {
        id
        allowedCognitoGroups
        firstName
        infix
        lastName
        gender
        Subscriptions {
          nextToken
          startedAt
        }
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Languages {
          nextToken
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        LanguageLabels {
          nextToken
          startedAt
        }
        userID
        User {
          id
          teamGroup
          isActive
          email
          needsEmailChange
          firstName
          infix
          lastName
          avatarS3Url
          speakerID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languageID
      Language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languagedialectID
      LanguageDialect {
        id
        name
        ISO_639_2_dialect
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      content
      contentJson
      sentimentJson
      contentOrigin
      contentJsonOrigin
      sentimentJsonOrigin
      validationStatus
      feedbackMessage
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteLanguageLabel = /* GraphQL */ `
  mutation DeleteLanguageLabel(
    $input: DeleteLanguageLabelInput!
    $condition: ModelLanguageLabelConditionInput
  ) {
    deleteLanguageLabel(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      createdAt
      submittedAt
      validatedAt
      submitteduserID
      submittedUser {
        id
        teamGroup
        isActive
        email
        needsEmailChange
        firstName
        infix
        lastName
        avatarS3Url
        speakerID
        Speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        submittedLanguageLabels {
          nextToken
          startedAt
        }
        validatedLanguageLabels {
          nextToken
          startedAt
        }
        allowedContextchannels {
          nextToken
        }
        ContextchannelSubscriptions {
          nextToken
          startedAt
        }
        SessionSubscriptions {
          nextToken
          startedAt
        }
        SpeakerSubscriptions {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      validateduserID
      validatedUser {
        id
        teamGroup
        isActive
        email
        needsEmailChange
        firstName
        infix
        lastName
        avatarS3Url
        speakerID
        Speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        submittedLanguageLabels {
          nextToken
          startedAt
        }
        validatedLanguageLabels {
          nextToken
          startedAt
        }
        allowedContextchannels {
          nextToken
        }
        ContextchannelSubscriptions {
          nextToken
          startedAt
        }
        SessionSubscriptions {
          nextToken
          startedAt
        }
        SpeakerSubscriptions {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      clientID
      contextchannelID
      sessionID
      goldtranscriptID
      GoldTranscript {
        id
        allowedCognitoGroups
        validationProgressStatus
        LanguageLabels {
          nextToken
          startedAt
        }
        transcriptS3Key
        subtitlesSrtS3Key
        subtitlesVttS3Key
        subtitleStatus
        clientID
        sessionID
        Session {
          id
          createdAt
          name
          clientID
          allowedCognitoGroups
          gnlpOutputs
          title
          summary
          keywords
          rewrittenS3Key
          condensed
          category
          sourceFileS3Key
          s3ImageUrl
          metadataID
          audioID
          videoID
          autotranscriptID
          goldtranscriptID
          customtranscriptID
          metadataStatus
          audioStatus
          videoStatus
          transcriptionStatus
          diarizationStatus
          subtitleStatus
          gnlpStatus
          nlpStatus
          contextchannelID
          contactEmailAddresses
          validationProgressStatus
          extra
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      starttime
      endtime
      speakerID
      Speaker {
        id
        allowedCognitoGroups
        firstName
        infix
        lastName
        gender
        Subscriptions {
          nextToken
          startedAt
        }
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Languages {
          nextToken
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        LanguageLabels {
          nextToken
          startedAt
        }
        userID
        User {
          id
          teamGroup
          isActive
          email
          needsEmailChange
          firstName
          infix
          lastName
          avatarS3Url
          speakerID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languageID
      Language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languagedialectID
      LanguageDialect {
        id
        name
        ISO_639_2_dialect
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      content
      contentJson
      sentimentJson
      contentOrigin
      contentJsonOrigin
      sentimentJsonOrigin
      validationStatus
      feedbackMessage
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createNLPModel = /* GraphQL */ `
  mutation CreateNLPModel(
    $input: CreateNLPModelInput!
    $condition: ModelNLPModelConditionInput
  ) {
    createNLPModel(input: $input, condition: $condition) {
      id
      modelTrainedAt
      name
      huggingfaceRef
      pipelineParametersJson
      inferenceParametersJson
      otherParametersJson
      basemodelID
      BaseModel {
        id
        modelTrainedAt
        name
        huggingfaceRef
        pipelineParametersJson
        inferenceParametersJson
        otherParametersJson
        basemodelID
        BaseModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        ChildModels {
          nextToken
          startedAt
        }
        nlpmodeltypeID
        NLPModelType {
          id
          name
          huggingfaceTask
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      ChildModels {
        items {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      nlpmodeltypeID
      NLPModelType {
        id
        name
        huggingfaceTask
        NLPModels {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateNLPModel = /* GraphQL */ `
  mutation UpdateNLPModel(
    $input: UpdateNLPModelInput!
    $condition: ModelNLPModelConditionInput
  ) {
    updateNLPModel(input: $input, condition: $condition) {
      id
      modelTrainedAt
      name
      huggingfaceRef
      pipelineParametersJson
      inferenceParametersJson
      otherParametersJson
      basemodelID
      BaseModel {
        id
        modelTrainedAt
        name
        huggingfaceRef
        pipelineParametersJson
        inferenceParametersJson
        otherParametersJson
        basemodelID
        BaseModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        ChildModels {
          nextToken
          startedAt
        }
        nlpmodeltypeID
        NLPModelType {
          id
          name
          huggingfaceTask
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      ChildModels {
        items {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      nlpmodeltypeID
      NLPModelType {
        id
        name
        huggingfaceTask
        NLPModels {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteNLPModel = /* GraphQL */ `
  mutation DeleteNLPModel(
    $input: DeleteNLPModelInput!
    $condition: ModelNLPModelConditionInput
  ) {
    deleteNLPModel(input: $input, condition: $condition) {
      id
      modelTrainedAt
      name
      huggingfaceRef
      pipelineParametersJson
      inferenceParametersJson
      otherParametersJson
      basemodelID
      BaseModel {
        id
        modelTrainedAt
        name
        huggingfaceRef
        pipelineParametersJson
        inferenceParametersJson
        otherParametersJson
        basemodelID
        BaseModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        ChildModels {
          nextToken
          startedAt
        }
        nlpmodeltypeID
        NLPModelType {
          id
          name
          huggingfaceTask
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      ChildModels {
        items {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      nlpmodeltypeID
      NLPModelType {
        id
        name
        huggingfaceTask
        NLPModels {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createNLPModelType = /* GraphQL */ `
  mutation CreateNLPModelType(
    $input: CreateNLPModelTypeInput!
    $condition: ModelNLPModelTypeConditionInput
  ) {
    createNLPModelType(input: $input, condition: $condition) {
      id
      name
      huggingfaceTask
      NLPModels {
        items {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateNLPModelType = /* GraphQL */ `
  mutation UpdateNLPModelType(
    $input: UpdateNLPModelTypeInput!
    $condition: ModelNLPModelTypeConditionInput
  ) {
    updateNLPModelType(input: $input, condition: $condition) {
      id
      name
      huggingfaceTask
      NLPModels {
        items {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteNLPModelType = /* GraphQL */ `
  mutation DeleteNLPModelType(
    $input: DeleteNLPModelTypeInput!
    $condition: ModelNLPModelTypeConditionInput
  ) {
    deleteNLPModelType(input: $input, condition: $condition) {
      id
      name
      huggingfaceTask
      NLPModels {
        items {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createSpeaker = /* GraphQL */ `
  mutation CreateSpeaker(
    $input: CreateSpeakerInput!
    $condition: ModelSpeakerConditionInput
  ) {
    createSpeaker(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      firstName
      infix
      lastName
      gender
      Subscriptions {
        items {
          id
          createdAt
          userID
          speakerID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      languageID
      Language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      Languages {
        items {
          id
          createdAt
          isDefaultLanguage
          speakerID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Contextchannels {
        items {
          id
          createdAt
          contextchannelID
          speakerID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Sessions {
        items {
          id
          createdAt
          isDefaultSpeaker
          sessionID
          speakerID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      clientID
      Client {
        id
        displayName
        cognitoGroupName
        Contextchannels {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      LanguageLabels {
        items {
          id
          allowedCognitoGroups
          createdAt
          submittedAt
          validatedAt
          submitteduserID
          validateduserID
          clientID
          contextchannelID
          sessionID
          goldtranscriptID
          starttime
          endtime
          speakerID
          languageID
          languagedialectID
          content
          contentJson
          sentimentJson
          contentOrigin
          contentJsonOrigin
          sentimentJsonOrigin
          validationStatus
          feedbackMessage
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      userID
      User {
        id
        teamGroup
        isActive
        email
        needsEmailChange
        firstName
        infix
        lastName
        avatarS3Url
        speakerID
        Speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        submittedLanguageLabels {
          nextToken
          startedAt
        }
        validatedLanguageLabels {
          nextToken
          startedAt
        }
        allowedContextchannels {
          nextToken
        }
        ContextchannelSubscriptions {
          nextToken
          startedAt
        }
        SessionSubscriptions {
          nextToken
          startedAt
        }
        SpeakerSubscriptions {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateSpeaker = /* GraphQL */ `
  mutation UpdateSpeaker(
    $input: UpdateSpeakerInput!
    $condition: ModelSpeakerConditionInput
  ) {
    updateSpeaker(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      firstName
      infix
      lastName
      gender
      Subscriptions {
        items {
          id
          createdAt
          userID
          speakerID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      languageID
      Language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      Languages {
        items {
          id
          createdAt
          isDefaultLanguage
          speakerID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Contextchannels {
        items {
          id
          createdAt
          contextchannelID
          speakerID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Sessions {
        items {
          id
          createdAt
          isDefaultSpeaker
          sessionID
          speakerID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      clientID
      Client {
        id
        displayName
        cognitoGroupName
        Contextchannels {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      LanguageLabels {
        items {
          id
          allowedCognitoGroups
          createdAt
          submittedAt
          validatedAt
          submitteduserID
          validateduserID
          clientID
          contextchannelID
          sessionID
          goldtranscriptID
          starttime
          endtime
          speakerID
          languageID
          languagedialectID
          content
          contentJson
          sentimentJson
          contentOrigin
          contentJsonOrigin
          sentimentJsonOrigin
          validationStatus
          feedbackMessage
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      userID
      User {
        id
        teamGroup
        isActive
        email
        needsEmailChange
        firstName
        infix
        lastName
        avatarS3Url
        speakerID
        Speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        submittedLanguageLabels {
          nextToken
          startedAt
        }
        validatedLanguageLabels {
          nextToken
          startedAt
        }
        allowedContextchannels {
          nextToken
        }
        ContextchannelSubscriptions {
          nextToken
          startedAt
        }
        SessionSubscriptions {
          nextToken
          startedAt
        }
        SpeakerSubscriptions {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteSpeaker = /* GraphQL */ `
  mutation DeleteSpeaker(
    $input: DeleteSpeakerInput!
    $condition: ModelSpeakerConditionInput
  ) {
    deleteSpeaker(input: $input, condition: $condition) {
      id
      allowedCognitoGroups
      firstName
      infix
      lastName
      gender
      Subscriptions {
        items {
          id
          createdAt
          userID
          speakerID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      languageID
      Language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      Languages {
        items {
          id
          createdAt
          isDefaultLanguage
          speakerID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Contextchannels {
        items {
          id
          createdAt
          contextchannelID
          speakerID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Sessions {
        items {
          id
          createdAt
          isDefaultSpeaker
          sessionID
          speakerID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      clientID
      Client {
        id
        displayName
        cognitoGroupName
        Contextchannels {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      LanguageLabels {
        items {
          id
          allowedCognitoGroups
          createdAt
          submittedAt
          validatedAt
          submitteduserID
          validateduserID
          clientID
          contextchannelID
          sessionID
          goldtranscriptID
          starttime
          endtime
          speakerID
          languageID
          languagedialectID
          content
          contentJson
          sentimentJson
          contentOrigin
          contentJsonOrigin
          sentimentJsonOrigin
          validationStatus
          feedbackMessage
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      userID
      User {
        id
        teamGroup
        isActive
        email
        needsEmailChange
        firstName
        infix
        lastName
        avatarS3Url
        speakerID
        Speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        submittedLanguageLabels {
          nextToken
          startedAt
        }
        validatedLanguageLabels {
          nextToken
          startedAt
        }
        allowedContextchannels {
          nextToken
        }
        ContextchannelSubscriptions {
          nextToken
          startedAt
        }
        SessionSubscriptions {
          nextToken
          startedAt
        }
        SpeakerSubscriptions {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createSpeakerLanguages = /* GraphQL */ `
  mutation CreateSpeakerLanguages(
    $input: CreateSpeakerLanguagesInput!
    $condition: ModelSpeakerLanguagesConditionInput
  ) {
    createSpeakerLanguages(input: $input, condition: $condition) {
      id
      createdAt
      isDefaultLanguage
      speakerID
      speaker {
        id
        allowedCognitoGroups
        firstName
        infix
        lastName
        gender
        Subscriptions {
          nextToken
          startedAt
        }
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Languages {
          nextToken
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        LanguageLabels {
          nextToken
          startedAt
        }
        userID
        User {
          id
          teamGroup
          isActive
          email
          needsEmailChange
          firstName
          infix
          lastName
          avatarS3Url
          speakerID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languageID
      language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      dialects {
        items {
          id
          createdAt
          isDefaultLanguageDialect
          speakerlanguageID
          languagedialectID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateSpeakerLanguages = /* GraphQL */ `
  mutation UpdateSpeakerLanguages(
    $input: UpdateSpeakerLanguagesInput!
    $condition: ModelSpeakerLanguagesConditionInput
  ) {
    updateSpeakerLanguages(input: $input, condition: $condition) {
      id
      createdAt
      isDefaultLanguage
      speakerID
      speaker {
        id
        allowedCognitoGroups
        firstName
        infix
        lastName
        gender
        Subscriptions {
          nextToken
          startedAt
        }
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Languages {
          nextToken
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        LanguageLabels {
          nextToken
          startedAt
        }
        userID
        User {
          id
          teamGroup
          isActive
          email
          needsEmailChange
          firstName
          infix
          lastName
          avatarS3Url
          speakerID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languageID
      language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      dialects {
        items {
          id
          createdAt
          isDefaultLanguageDialect
          speakerlanguageID
          languagedialectID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteSpeakerLanguages = /* GraphQL */ `
  mutation DeleteSpeakerLanguages(
    $input: DeleteSpeakerLanguagesInput!
    $condition: ModelSpeakerLanguagesConditionInput
  ) {
    deleteSpeakerLanguages(input: $input, condition: $condition) {
      id
      createdAt
      isDefaultLanguage
      speakerID
      speaker {
        id
        allowedCognitoGroups
        firstName
        infix
        lastName
        gender
        Subscriptions {
          nextToken
          startedAt
        }
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Languages {
          nextToken
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        LanguageLabels {
          nextToken
          startedAt
        }
        userID
        User {
          id
          teamGroup
          isActive
          email
          needsEmailChange
          firstName
          infix
          lastName
          avatarS3Url
          speakerID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languageID
      language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      dialects {
        items {
          id
          createdAt
          isDefaultLanguageDialect
          speakerlanguageID
          languagedialectID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createSpeakerLanguageLanguageDialects = /* GraphQL */ `
  mutation CreateSpeakerLanguageLanguageDialects(
    $input: CreateSpeakerLanguageLanguageDialectsInput!
    $condition: ModelSpeakerLanguageLanguageDialectsConditionInput
  ) {
    createSpeakerLanguageLanguageDialects(
      input: $input
      condition: $condition
    ) {
      id
      createdAt
      isDefaultLanguageDialect
      speakerlanguageID
      speakerlanguage {
        id
        createdAt
        isDefaultLanguage
        speakerID
        speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        languageID
        language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        dialects {
          nextToken
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languagedialectID
      languagedialect {
        id
        name
        ISO_639_2_dialect
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateSpeakerLanguageLanguageDialects = /* GraphQL */ `
  mutation UpdateSpeakerLanguageLanguageDialects(
    $input: UpdateSpeakerLanguageLanguageDialectsInput!
    $condition: ModelSpeakerLanguageLanguageDialectsConditionInput
  ) {
    updateSpeakerLanguageLanguageDialects(
      input: $input
      condition: $condition
    ) {
      id
      createdAt
      isDefaultLanguageDialect
      speakerlanguageID
      speakerlanguage {
        id
        createdAt
        isDefaultLanguage
        speakerID
        speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        languageID
        language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        dialects {
          nextToken
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languagedialectID
      languagedialect {
        id
        name
        ISO_639_2_dialect
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteSpeakerLanguageLanguageDialects = /* GraphQL */ `
  mutation DeleteSpeakerLanguageLanguageDialects(
    $input: DeleteSpeakerLanguageLanguageDialectsInput!
    $condition: ModelSpeakerLanguageLanguageDialectsConditionInput
  ) {
    deleteSpeakerLanguageLanguageDialects(
      input: $input
      condition: $condition
    ) {
      id
      createdAt
      isDefaultLanguageDialect
      speakerlanguageID
      speakerlanguage {
        id
        createdAt
        isDefaultLanguage
        speakerID
        speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        languageID
        language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        dialects {
          nextToken
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      languagedialectID
      languagedialect {
        id
        name
        ISO_639_2_dialect
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createLanguage = /* GraphQL */ `
  mutation CreateLanguage(
    $input: CreateLanguageInput!
    $condition: ModelLanguageConditionInput
  ) {
    createLanguage(input: $input, condition: $condition) {
      id
      name
      ISO_639_1
      ISO_639_2
      ISO_639_3
      stopwords
      LanguageDialects {
        items {
          id
          name
          ISO_639_2_dialect
          languageID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      SpeechModels {
        items {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      Contextchannels {
        items {
          id
          createdAt
          enabled
          contextchannelID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      NLPSteps {
        items {
          id
          createdAt
          formality
          nlpstepID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Sessions {
        items {
          id
          createdAt
          isDefaultLanguage
          sessionID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Speakers {
        items {
          id
          createdAt
          isDefaultLanguage
          speakerID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateLanguage = /* GraphQL */ `
  mutation UpdateLanguage(
    $input: UpdateLanguageInput!
    $condition: ModelLanguageConditionInput
  ) {
    updateLanguage(input: $input, condition: $condition) {
      id
      name
      ISO_639_1
      ISO_639_2
      ISO_639_3
      stopwords
      LanguageDialects {
        items {
          id
          name
          ISO_639_2_dialect
          languageID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      SpeechModels {
        items {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      Contextchannels {
        items {
          id
          createdAt
          enabled
          contextchannelID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      NLPSteps {
        items {
          id
          createdAt
          formality
          nlpstepID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Sessions {
        items {
          id
          createdAt
          isDefaultLanguage
          sessionID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Speakers {
        items {
          id
          createdAt
          isDefaultLanguage
          speakerID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteLanguage = /* GraphQL */ `
  mutation DeleteLanguage(
    $input: DeleteLanguageInput!
    $condition: ModelLanguageConditionInput
  ) {
    deleteLanguage(input: $input, condition: $condition) {
      id
      name
      ISO_639_1
      ISO_639_2
      ISO_639_3
      stopwords
      LanguageDialects {
        items {
          id
          name
          ISO_639_2_dialect
          languageID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      SpeechModels {
        items {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      Contextchannels {
        items {
          id
          createdAt
          enabled
          contextchannelID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      NLPSteps {
        items {
          id
          createdAt
          formality
          nlpstepID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Sessions {
        items {
          id
          createdAt
          isDefaultLanguage
          sessionID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Speakers {
        items {
          id
          createdAt
          isDefaultLanguage
          speakerID
          languageID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createLanguageDialect = /* GraphQL */ `
  mutation CreateLanguageDialect(
    $input: CreateLanguageDialectInput!
    $condition: ModelLanguageDialectConditionInput
  ) {
    createLanguageDialect(input: $input, condition: $condition) {
      id
      name
      ISO_639_2_dialect
      languageID
      Language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      SpeechModels {
        items {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      Contextchannels {
        items {
          id
          createdAt
          enabled
          contextchannellanguageID
          languagedialectID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Sessions {
        items {
          id
          createdAt
          isDefaultLanguageDialect
          sessionlanguageID
          languagedialectID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Speakers {
        items {
          id
          createdAt
          isDefaultLanguageDialect
          speakerlanguageID
          languagedialectID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateLanguageDialect = /* GraphQL */ `
  mutation UpdateLanguageDialect(
    $input: UpdateLanguageDialectInput!
    $condition: ModelLanguageDialectConditionInput
  ) {
    updateLanguageDialect(input: $input, condition: $condition) {
      id
      name
      ISO_639_2_dialect
      languageID
      Language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      SpeechModels {
        items {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      Contextchannels {
        items {
          id
          createdAt
          enabled
          contextchannellanguageID
          languagedialectID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Sessions {
        items {
          id
          createdAt
          isDefaultLanguageDialect
          sessionlanguageID
          languagedialectID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Speakers {
        items {
          id
          createdAt
          isDefaultLanguageDialect
          speakerlanguageID
          languagedialectID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteLanguageDialect = /* GraphQL */ `
  mutation DeleteLanguageDialect(
    $input: DeleteLanguageDialectInput!
    $condition: ModelLanguageDialectConditionInput
  ) {
    deleteLanguageDialect(input: $input, condition: $condition) {
      id
      name
      ISO_639_2_dialect
      languageID
      Language {
        id
        name
        ISO_639_1
        ISO_639_2
        ISO_639_3
        stopwords
        LanguageDialects {
          nextToken
          startedAt
        }
        SpeechModels {
          nextToken
          startedAt
        }
        Contextchannels {
          nextToken
        }
        NLPSteps {
          nextToken
        }
        Sessions {
          nextToken
        }
        Speakers {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      SpeechModels {
        items {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      Contextchannels {
        items {
          id
          createdAt
          enabled
          contextchannellanguageID
          languagedialectID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Sessions {
        items {
          id
          createdAt
          isDefaultLanguageDialect
          sessionlanguageID
          languagedialectID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      Speakers {
        items {
          id
          createdAt
          isDefaultLanguageDialect
          speakerlanguageID
          languagedialectID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      teamGroup
      isActive
      email
      needsEmailChange
      firstName
      infix
      lastName
      avatarS3Url
      speakerID
      Speaker {
        id
        allowedCognitoGroups
        firstName
        infix
        lastName
        gender
        Subscriptions {
          nextToken
          startedAt
        }
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Languages {
          nextToken
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        LanguageLabels {
          nextToken
          startedAt
        }
        userID
        User {
          id
          teamGroup
          isActive
          email
          needsEmailChange
          firstName
          infix
          lastName
          avatarS3Url
          speakerID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      submittedLanguageLabels {
        items {
          id
          allowedCognitoGroups
          createdAt
          submittedAt
          validatedAt
          submitteduserID
          validateduserID
          clientID
          contextchannelID
          sessionID
          goldtranscriptID
          starttime
          endtime
          speakerID
          languageID
          languagedialectID
          content
          contentJson
          sentimentJson
          contentOrigin
          contentJsonOrigin
          sentimentJsonOrigin
          validationStatus
          feedbackMessage
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      validatedLanguageLabels {
        items {
          id
          allowedCognitoGroups
          createdAt
          submittedAt
          validatedAt
          submitteduserID
          validateduserID
          clientID
          contextchannelID
          sessionID
          goldtranscriptID
          starttime
          endtime
          speakerID
          languageID
          languagedialectID
          content
          contentJson
          sentimentJson
          contentOrigin
          contentJsonOrigin
          sentimentJsonOrigin
          validationStatus
          feedbackMessage
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      allowedContextchannels {
        items {
          id
          createdAt
          isActive
          userID
          contextchannelID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      ContextchannelSubscriptions {
        items {
          id
          createdAt
          userID
          contextchannelID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      SessionSubscriptions {
        items {
          id
          createdAt
          userID
          sessionID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      SpeakerSubscriptions {
        items {
          id
          createdAt
          userID
          speakerID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      teamGroup
      isActive
      email
      needsEmailChange
      firstName
      infix
      lastName
      avatarS3Url
      speakerID
      Speaker {
        id
        allowedCognitoGroups
        firstName
        infix
        lastName
        gender
        Subscriptions {
          nextToken
          startedAt
        }
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Languages {
          nextToken
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        LanguageLabels {
          nextToken
          startedAt
        }
        userID
        User {
          id
          teamGroup
          isActive
          email
          needsEmailChange
          firstName
          infix
          lastName
          avatarS3Url
          speakerID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      submittedLanguageLabels {
        items {
          id
          allowedCognitoGroups
          createdAt
          submittedAt
          validatedAt
          submitteduserID
          validateduserID
          clientID
          contextchannelID
          sessionID
          goldtranscriptID
          starttime
          endtime
          speakerID
          languageID
          languagedialectID
          content
          contentJson
          sentimentJson
          contentOrigin
          contentJsonOrigin
          sentimentJsonOrigin
          validationStatus
          feedbackMessage
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      validatedLanguageLabels {
        items {
          id
          allowedCognitoGroups
          createdAt
          submittedAt
          validatedAt
          submitteduserID
          validateduserID
          clientID
          contextchannelID
          sessionID
          goldtranscriptID
          starttime
          endtime
          speakerID
          languageID
          languagedialectID
          content
          contentJson
          sentimentJson
          contentOrigin
          contentJsonOrigin
          sentimentJsonOrigin
          validationStatus
          feedbackMessage
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      allowedContextchannels {
        items {
          id
          createdAt
          isActive
          userID
          contextchannelID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      ContextchannelSubscriptions {
        items {
          id
          createdAt
          userID
          contextchannelID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      SessionSubscriptions {
        items {
          id
          createdAt
          userID
          sessionID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      SpeakerSubscriptions {
        items {
          id
          createdAt
          userID
          speakerID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      teamGroup
      isActive
      email
      needsEmailChange
      firstName
      infix
      lastName
      avatarS3Url
      speakerID
      Speaker {
        id
        allowedCognitoGroups
        firstName
        infix
        lastName
        gender
        Subscriptions {
          nextToken
          startedAt
        }
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Languages {
          nextToken
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        LanguageLabels {
          nextToken
          startedAt
        }
        userID
        User {
          id
          teamGroup
          isActive
          email
          needsEmailChange
          firstName
          infix
          lastName
          avatarS3Url
          speakerID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      submittedLanguageLabels {
        items {
          id
          allowedCognitoGroups
          createdAt
          submittedAt
          validatedAt
          submitteduserID
          validateduserID
          clientID
          contextchannelID
          sessionID
          goldtranscriptID
          starttime
          endtime
          speakerID
          languageID
          languagedialectID
          content
          contentJson
          sentimentJson
          contentOrigin
          contentJsonOrigin
          sentimentJsonOrigin
          validationStatus
          feedbackMessage
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      validatedLanguageLabels {
        items {
          id
          allowedCognitoGroups
          createdAt
          submittedAt
          validatedAt
          submitteduserID
          validateduserID
          clientID
          contextchannelID
          sessionID
          goldtranscriptID
          starttime
          endtime
          speakerID
          languageID
          languagedialectID
          content
          contentJson
          sentimentJson
          contentOrigin
          contentJsonOrigin
          sentimentJsonOrigin
          validationStatus
          feedbackMessage
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      allowedContextchannels {
        items {
          id
          createdAt
          isActive
          userID
          contextchannelID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      ContextchannelSubscriptions {
        items {
          id
          createdAt
          userID
          contextchannelID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      SessionSubscriptions {
        items {
          id
          createdAt
          userID
          sessionID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      SpeakerSubscriptions {
        items {
          id
          createdAt
          userID
          speakerID
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createUserContextchannels = /* GraphQL */ `
  mutation CreateUserContextchannels(
    $input: CreateUserContextchannelsInput!
    $condition: ModelUserContextchannelsConditionInput
  ) {
    createUserContextchannels(input: $input, condition: $condition) {
      id
      createdAt
      isActive
      userID
      user {
        id
        teamGroup
        isActive
        email
        needsEmailChange
        firstName
        infix
        lastName
        avatarS3Url
        speakerID
        Speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        submittedLanguageLabels {
          nextToken
          startedAt
        }
        validatedLanguageLabels {
          nextToken
          startedAt
        }
        allowedContextchannels {
          nextToken
        }
        ContextchannelSubscriptions {
          nextToken
          startedAt
        }
        SessionSubscriptions {
          nextToken
          startedAt
        }
        SpeakerSubscriptions {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      contextchannelID
      contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateUserContextchannels = /* GraphQL */ `
  mutation UpdateUserContextchannels(
    $input: UpdateUserContextchannelsInput!
    $condition: ModelUserContextchannelsConditionInput
  ) {
    updateUserContextchannels(input: $input, condition: $condition) {
      id
      createdAt
      isActive
      userID
      user {
        id
        teamGroup
        isActive
        email
        needsEmailChange
        firstName
        infix
        lastName
        avatarS3Url
        speakerID
        Speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        submittedLanguageLabels {
          nextToken
          startedAt
        }
        validatedLanguageLabels {
          nextToken
          startedAt
        }
        allowedContextchannels {
          nextToken
        }
        ContextchannelSubscriptions {
          nextToken
          startedAt
        }
        SessionSubscriptions {
          nextToken
          startedAt
        }
        SpeakerSubscriptions {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      contextchannelID
      contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteUserContextchannels = /* GraphQL */ `
  mutation DeleteUserContextchannels(
    $input: DeleteUserContextchannelsInput!
    $condition: ModelUserContextchannelsConditionInput
  ) {
    deleteUserContextchannels(input: $input, condition: $condition) {
      id
      createdAt
      isActive
      userID
      user {
        id
        teamGroup
        isActive
        email
        needsEmailChange
        firstName
        infix
        lastName
        avatarS3Url
        speakerID
        Speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        submittedLanguageLabels {
          nextToken
          startedAt
        }
        validatedLanguageLabels {
          nextToken
          startedAt
        }
        allowedContextchannels {
          nextToken
        }
        ContextchannelSubscriptions {
          nextToken
          startedAt
        }
        SessionSubscriptions {
          nextToken
          startedAt
        }
        SpeakerSubscriptions {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      contextchannelID
      contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createContextchannelSubscription = /* GraphQL */ `
  mutation CreateContextchannelSubscription(
    $input: CreateContextchannelSubscriptionInput!
    $condition: ModelContextchannelSubscriptionConditionInput
  ) {
    createContextchannelSubscription(input: $input, condition: $condition) {
      id
      createdAt
      userID
      user {
        id
        teamGroup
        isActive
        email
        needsEmailChange
        firstName
        infix
        lastName
        avatarS3Url
        speakerID
        Speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        submittedLanguageLabels {
          nextToken
          startedAt
        }
        validatedLanguageLabels {
          nextToken
          startedAt
        }
        allowedContextchannels {
          nextToken
        }
        ContextchannelSubscriptions {
          nextToken
          startedAt
        }
        SessionSubscriptions {
          nextToken
          startedAt
        }
        SpeakerSubscriptions {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      contextchannelID
      contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateContextchannelSubscription = /* GraphQL */ `
  mutation UpdateContextchannelSubscription(
    $input: UpdateContextchannelSubscriptionInput!
    $condition: ModelContextchannelSubscriptionConditionInput
  ) {
    updateContextchannelSubscription(input: $input, condition: $condition) {
      id
      createdAt
      userID
      user {
        id
        teamGroup
        isActive
        email
        needsEmailChange
        firstName
        infix
        lastName
        avatarS3Url
        speakerID
        Speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        submittedLanguageLabels {
          nextToken
          startedAt
        }
        validatedLanguageLabels {
          nextToken
          startedAt
        }
        allowedContextchannels {
          nextToken
        }
        ContextchannelSubscriptions {
          nextToken
          startedAt
        }
        SessionSubscriptions {
          nextToken
          startedAt
        }
        SpeakerSubscriptions {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      contextchannelID
      contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteContextchannelSubscription = /* GraphQL */ `
  mutation DeleteContextchannelSubscription(
    $input: DeleteContextchannelSubscriptionInput!
    $condition: ModelContextchannelSubscriptionConditionInput
  ) {
    deleteContextchannelSubscription(input: $input, condition: $condition) {
      id
      createdAt
      userID
      user {
        id
        teamGroup
        isActive
        email
        needsEmailChange
        firstName
        infix
        lastName
        avatarS3Url
        speakerID
        Speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        submittedLanguageLabels {
          nextToken
          startedAt
        }
        validatedLanguageLabels {
          nextToken
          startedAt
        }
        allowedContextchannels {
          nextToken
        }
        ContextchannelSubscriptions {
          nextToken
          startedAt
        }
        SessionSubscriptions {
          nextToken
          startedAt
        }
        SpeakerSubscriptions {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      contextchannelID
      contextchannel {
        id
        allowedCognitoGroups
        name
        s3ImageUrl
        reference_id
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        allowedUsers {
          nextToken
        }
        dynamicConfig
        wordTaggerModuleSettings {
          enabled
          categories
        }
        gnlpConfig {
          prompt
          maxTokens
          temperature
          key
          frequencyPenalty
          presencePenalty
          languageISO
        }
        gnlpTasks
        speechmodelID
        SpeechModel {
          id
          name
          description
          s3ImageUrl
          allowedCognitoGroups
          provider
          connectionString
          languageID
          languagedialectID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        wordcloudSettings {
          whitelist
          blacklist
        }
        precomputedWordCountsS3Key
        ClusteringModuleOutputs {
          nextToken
          startedAt
        }
        NLPSteps {
          nextToken
          startedAt
        }
        posmodelID
        POSModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nermodelID
        NERModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        summarymodelID
        SummaryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        sentimentmodelID
        SentimentModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        categorymodelID
        CategoryModel {
          id
          modelTrainedAt
          name
          huggingfaceRef
          pipelineParametersJson
          inferenceParametersJson
          otherParametersJson
          basemodelID
          nlpmodeltypeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Sessions {
          nextToken
          startedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        ContextchannelLogs {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createSessionSubscription = /* GraphQL */ `
  mutation CreateSessionSubscription(
    $input: CreateSessionSubscriptionInput!
    $condition: ModelSessionSubscriptionConditionInput
  ) {
    createSessionSubscription(input: $input, condition: $condition) {
      id
      createdAt
      userID
      user {
        id
        teamGroup
        isActive
        email
        needsEmailChange
        firstName
        infix
        lastName
        avatarS3Url
        speakerID
        Speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        submittedLanguageLabels {
          nextToken
          startedAt
        }
        validatedLanguageLabels {
          nextToken
          startedAt
        }
        allowedContextchannels {
          nextToken
        }
        ContextchannelSubscriptions {
          nextToken
          startedAt
        }
        SessionSubscriptions {
          nextToken
          startedAt
        }
        SpeakerSubscriptions {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      sessionID
      session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateSessionSubscription = /* GraphQL */ `
  mutation UpdateSessionSubscription(
    $input: UpdateSessionSubscriptionInput!
    $condition: ModelSessionSubscriptionConditionInput
  ) {
    updateSessionSubscription(input: $input, condition: $condition) {
      id
      createdAt
      userID
      user {
        id
        teamGroup
        isActive
        email
        needsEmailChange
        firstName
        infix
        lastName
        avatarS3Url
        speakerID
        Speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        submittedLanguageLabels {
          nextToken
          startedAt
        }
        validatedLanguageLabels {
          nextToken
          startedAt
        }
        allowedContextchannels {
          nextToken
        }
        ContextchannelSubscriptions {
          nextToken
          startedAt
        }
        SessionSubscriptions {
          nextToken
          startedAt
        }
        SpeakerSubscriptions {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      sessionID
      session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteSessionSubscription = /* GraphQL */ `
  mutation DeleteSessionSubscription(
    $input: DeleteSessionSubscriptionInput!
    $condition: ModelSessionSubscriptionConditionInput
  ) {
    deleteSessionSubscription(input: $input, condition: $condition) {
      id
      createdAt
      userID
      user {
        id
        teamGroup
        isActive
        email
        needsEmailChange
        firstName
        infix
        lastName
        avatarS3Url
        speakerID
        Speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        submittedLanguageLabels {
          nextToken
          startedAt
        }
        validatedLanguageLabels {
          nextToken
          startedAt
        }
        allowedContextchannels {
          nextToken
        }
        ContextchannelSubscriptions {
          nextToken
          startedAt
        }
        SessionSubscriptions {
          nextToken
          startedAt
        }
        SpeakerSubscriptions {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      sessionID
      session {
        id
        createdAt
        name
        clientID
        allowedCognitoGroups
        wordcloudSettings {
          whitelist
          blacklist
        }
        wordTaggerModuleOutputs {
          nextToken
          startedAt
        }
        gnlpOutputs
        NLPOutputs {
          nextToken
          startedAt
        }
        title
        summary
        keywords
        rewrittenS3Key
        condensed
        category
        sourceFileS3Key
        s3ImageUrl
        metadataID
        Metadata {
          id
          allowedCognitoGroups
          metadataS3Key
          durationSeconds
          metadataStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        audioID
        Audio {
          id
          allowedCognitoGroups
          uncompressedAudioS3Key
          compressedAudioS3Key
          waveformDataS3Key
          audioStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        videoID
        Video {
          id
          allowedCognitoGroups
          compressedVideoS3Key
          videoStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        autotranscriptID
        AutoTranscript {
          id
          allowedCognitoGroups
          speechmodelID
          transcriptSourceS3Key
          transcriptStandardizedS3Key
          transcriptTranslationS3Keys
          transcriptionStatus
          exportPlainTextS3Key
          exportJsonS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          diarizationS3Key
          summaryS3Key
          categoriesJson
          autotranscriptstatsID
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        goldtranscriptID
        GoldTranscript {
          id
          allowedCognitoGroups
          validationProgressStatus
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        customtranscriptID
        CustomTranscript {
          id
          allowedCognitoGroups
          transcriptS3Key
          subtitlesSrtS3Key
          subtitlesVttS3Key
          subtitleStatus
          clientID
          sessionID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        metadataStatus
        audioStatus
        videoStatus
        transcriptionStatus
        diarizationStatus
        subtitleStatus
        gnlpStatus
        nlpStatus
        contextchannelID
        Contextchannel {
          id
          allowedCognitoGroups
          name
          s3ImageUrl
          reference_id
          contactEmailAddresses
          dynamicConfig
          gnlpTasks
          speechmodelID
          precomputedWordCountsS3Key
          posmodelID
          nermodelID
          summarymodelID
          sentimentmodelID
          categorymodelID
          clientID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Speakers {
          nextToken
        }
        Languages {
          nextToken
        }
        contactEmailAddresses
        Subscriptions {
          nextToken
          startedAt
        }
        validationProgressStatus
        extra
        tags {
          key
          value
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createSpeakerSubscription = /* GraphQL */ `
  mutation CreateSpeakerSubscription(
    $input: CreateSpeakerSubscriptionInput!
    $condition: ModelSpeakerSubscriptionConditionInput
  ) {
    createSpeakerSubscription(input: $input, condition: $condition) {
      id
      createdAt
      userID
      user {
        id
        teamGroup
        isActive
        email
        needsEmailChange
        firstName
        infix
        lastName
        avatarS3Url
        speakerID
        Speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        submittedLanguageLabels {
          nextToken
          startedAt
        }
        validatedLanguageLabels {
          nextToken
          startedAt
        }
        allowedContextchannels {
          nextToken
        }
        ContextchannelSubscriptions {
          nextToken
          startedAt
        }
        SessionSubscriptions {
          nextToken
          startedAt
        }
        SpeakerSubscriptions {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      speakerID
      speaker {
        id
        allowedCognitoGroups
        firstName
        infix
        lastName
        gender
        Subscriptions {
          nextToken
          startedAt
        }
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Languages {
          nextToken
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        LanguageLabels {
          nextToken
          startedAt
        }
        userID
        User {
          id
          teamGroup
          isActive
          email
          needsEmailChange
          firstName
          infix
          lastName
          avatarS3Url
          speakerID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateSpeakerSubscription = /* GraphQL */ `
  mutation UpdateSpeakerSubscription(
    $input: UpdateSpeakerSubscriptionInput!
    $condition: ModelSpeakerSubscriptionConditionInput
  ) {
    updateSpeakerSubscription(input: $input, condition: $condition) {
      id
      createdAt
      userID
      user {
        id
        teamGroup
        isActive
        email
        needsEmailChange
        firstName
        infix
        lastName
        avatarS3Url
        speakerID
        Speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        submittedLanguageLabels {
          nextToken
          startedAt
        }
        validatedLanguageLabels {
          nextToken
          startedAt
        }
        allowedContextchannels {
          nextToken
        }
        ContextchannelSubscriptions {
          nextToken
          startedAt
        }
        SessionSubscriptions {
          nextToken
          startedAt
        }
        SpeakerSubscriptions {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      speakerID
      speaker {
        id
        allowedCognitoGroups
        firstName
        infix
        lastName
        gender
        Subscriptions {
          nextToken
          startedAt
        }
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Languages {
          nextToken
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        LanguageLabels {
          nextToken
          startedAt
        }
        userID
        User {
          id
          teamGroup
          isActive
          email
          needsEmailChange
          firstName
          infix
          lastName
          avatarS3Url
          speakerID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteSpeakerSubscription = /* GraphQL */ `
  mutation DeleteSpeakerSubscription(
    $input: DeleteSpeakerSubscriptionInput!
    $condition: ModelSpeakerSubscriptionConditionInput
  ) {
    deleteSpeakerSubscription(input: $input, condition: $condition) {
      id
      createdAt
      userID
      user {
        id
        teamGroup
        isActive
        email
        needsEmailChange
        firstName
        infix
        lastName
        avatarS3Url
        speakerID
        Speaker {
          id
          allowedCognitoGroups
          firstName
          infix
          lastName
          gender
          languageID
          clientID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        submittedLanguageLabels {
          nextToken
          startedAt
        }
        validatedLanguageLabels {
          nextToken
          startedAt
        }
        allowedContextchannels {
          nextToken
        }
        ContextchannelSubscriptions {
          nextToken
          startedAt
        }
        SessionSubscriptions {
          nextToken
          startedAt
        }
        SpeakerSubscriptions {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      speakerID
      speaker {
        id
        allowedCognitoGroups
        firstName
        infix
        lastName
        gender
        Subscriptions {
          nextToken
          startedAt
        }
        languageID
        Language {
          id
          name
          ISO_639_1
          ISO_639_2
          ISO_639_3
          stopwords
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        Languages {
          nextToken
        }
        Contextchannels {
          nextToken
        }
        Sessions {
          nextToken
        }
        clientID
        Client {
          id
          displayName
          cognitoGroupName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        LanguageLabels {
          nextToken
          startedAt
        }
        userID
        User {
          id
          teamGroup
          isActive
          email
          needsEmailChange
          firstName
          infix
          lastName
          avatarS3Url
          speakerID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
